import Breadcrumbs from "components/Common/BreadCrumbs";
import { renderStars } from "components/Common/commonFunctions";
import CustomModal from "pages/ProductManagement/CustomModal";
import React, { useRef, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import {
  ChangeTechnician,
  ContinueJob,
  JobWarranty,
  SendQuotation,
  SparePartsSelection,
  ServiceSelection,
  ApplyDiscount,
  AcceptQuotation,
} from "./JobActionFunctions";
import { UploadJobFiles } from "./UploadJobFiles";
import { showAlert, ActionButton } from "components/Common/commonFunctions";
import {
  getJobByID,
  getJobTimeLineByID,
  getTechnicalReportByID,
} from "actions/job";
import QuotationAndPayments from "./QuotationAndPayments";
import MediaAndDocuments from "./MediaAndDocuments";
import { RescheduleJob } from "./RescheduleJob";
import { urlDecodedId } from "components/Common/encodeDecodeFunction";
import { JOB_STATUS, PAYMENT_TERMS_STATUS } from "components/Common/constants";
import { downloadQuotationHistory } from "actions/jobQuotation";
import { JobLogs } from "./JobLogs";
import { AddTechnicalReport } from "./AddTechnicalReport";
import { getFeedbackByID } from "actions/job";
import {
  addQuotation,
  editQuotation,
  getQuotationList,
  updateStatusQuotation,
} from "actions/quotation";
import NotificationAlert from "react-notification-alert";
import { useDispatch, useSelector } from "react-redux";
import { sendQuotation } from "actions/quotation";
import { cancelJobByJobId } from "actions/job";
import { completeJobByJobID } from "actions/job";
import { quotationRequote } from "actions/jobQuotation";
import { updateJobStatus } from "actions/job";
import { downloadJobReportByJobId } from "actions/job";
import { updateJobToContinue } from "actions/job";
import { updateAdminNote } from "actions/job";
import { getJobQuotationHistory } from "actions/jobQuotation";
import {
  updateSalesOrderNumber,
  recordBankTransfer,
  reopenJob,
  getPaymentDetails,
} from "actions/job";
import { downloadProductManual } from "actions/product";
import { downloadEquipmentInvoice } from "actions/customerEquipment";
import { WORK_ORDER, SMALL_CASE_WORK_ORDER } from "components/Common/constants";
import { updateInternalMonitoring } from "actions/job";
import { toTitleCase } from "components/Common/commonFunctions";

const initialFields = {
  customer: {
    value: "",
    label: "",
    phone: "",
    email: "",
    address: "",
  },
  customerLocation: {
    value: "",
    outletName: "",
    address: "",
    contactPersonName: "",
    contactPersonPhone: "",
    contactEmail: "",
    alternateContactPersonName: "",
    alternateContactPersonPhone: "",
    alternateContactEmail: "",
    regionID: "",
    companyName: ""
  },
  customerEquipment: {
    value: "",
    assetTag: "",
    invoicePath: "",
    seller: "",
    serialNo: "",
    status: "",
    underWarranty: "",
  },

  jobTypeID: { value: "", label: "" },
  technician: { value: "", label: "" },

  manufacturer: { value: "", label: "" },
  product: { value: "", label: "", modelNo: "" },

  scheduledFrom: "",
  scheduledTo: "",

  priority: "",
  jobStatus: "",

  clientNote: "",
  adminNote: { value: "", error: "" },
  partsNote: "",
  warrantyNote: "",

  partRequestedReceivedOn: "",
  partRequestedEtaDate: "",
  partRequestedStatus: "",
  purchaseDate: "",

  jobReferenceNo: { value: "", error: "" },
  jobSalesOrderNo: "",
  partsPurchaseOrderNo: "",
  paymentTerm: { ID: 0, term: "" },
};

const techinicalReportInitialState = {
  ID: { value: "", error: "" },
  jobID: "",
  technicianID: { value: "", label: "", error: "" },
  serialNo: { value: "", error: "" },
  causeOfFailure: { value: "", error: "" },
  additionalInfo: { value: "", error: "" },
  otherFinding: { value: "", error: "" },
  media: [],
};

const TIMELINE_UI_MAP = {
  JOB_CREATED: {
    icon: "icon-badge",
    color: "secondary",
  },
  TECHNICIAN_ASSIGNED: {
    icon: "icon-single-02",
    color: "info",
  },
  TECHNICIAN_CHANGED: {
    icon: "icon-refresh-01",
    color: "info",
  },
  QUOTATION_CREATED: {
    icon: "icon-notes",
    color: "info",
  },
  REQUEST_APPROVAL: {
    icon: "icon-time-alarm",
    color: "warning",
  },
  QUOTATION_REVISED: {
    icon: "icon-refresh-02",
    color: "warning",
  },
  QUOTATION_SENT: {
    icon: "icon-send",
    color: "info",
  },
  QUOTATION_APPROVED: {
    icon: "icon-check-2",
    color: "success",
  },
  QUOTATION_REJECTED: {
    icon: "icon-simple-remove",
    color: "danger",
  },
  PART_REQUESTS: {
    icon: "icon-cart",
    color: "info",
  },
  PARTS_ORDERED: {
    icon: "icon-delivery-fast",
    color: "info",
  },
  PART_ON_ORDER: {
    icon: "icon-delivery-fast",
    color: "success",
  },
  READY_FOR_PICKUP: {
    icon: "icon-app",
    color: "success",
  },
  PICKED_UP: {
    icon: "icon-basket-simple",
    color: "success",
  },
  REPAIR: {
    icon: "icon-settings",
    color: "info",
  },
  REPAIRED: {
    icon: "icon-check-2",
    color: "success",
  },
  PAYMENT_PAID: {
    icon: "icon-money-coins",
    color: "success",
  },
  PARTIAL_PAYMENT_PAID: {
    icon: "icon-money-coins",
    color: "success",
  },
  AWAITING_PAYMENT: {
    icon: "icon-credit-card",
    color: "warning",
  },
  JOB_CONTINUED: {
    icon: "icon-refresh-02",
    color: "warning",
  },
  JOB_COMPLETED: {
    icon: "icon-check-2",
    color: "success",
  },
  JOB_CANCELLED: {
    icon: "icon-simple-remove",
    color: "danger",
  },
  RESCHEDULED: {
    icon: "icon-calendar-60",
    color: "warning",
  },
  REWORK_REQUIRED: {
    icon: "icon-settings",
    color: "info",
  },
  INVOICE_PAID: {
    icon: "icon-trophy",
    color: "success",
  },
  JOB_REOPEN: {
    icon: "icon-refresh-02",
    color: "warning",
  },
  INVOICE_NOT_PAID: {
    icon: "icon-money-coins",
    color: "warning",
  },
  DEFAULT: {
    // it will show when statuses are not match above
    icon: "icon-bell-55",
    color: "primary",
  },
};

function JobDetails() {
  const { id: encodedId } = useParams();
  const decodedId = urlDecodedId(encodedId);
  const location = useLocation();
  const data = location.state || {};
  const notificationAlertRef = useRef(null);
  const [activeTab, setActiveTab] = useState("overview");
  const query = new URLSearchParams(location.search);
  const urlTab = query.get("tab");
  const [isEditing, setIsEditing] = useState({
    notes: { edit: false, value: "" },
    referenceNo: { edit: false, value: "" },
    poNo: { edit: false, value: "" },
    jobSalesOrderNo: { edit: false, value: "" },
  });
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedPDF, setSelectedPDF] = useState(null);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [jobFormData, setJobFormData] = useState(initialFields);
  const [timeline, setTimeline] = useState([]);
  const [techRepoFormData, setTechRepoFormData] = useState(
    techinicalReportInitialState,
  );
  const [feedback, setFeedback] = useState([]);
  const [requoteReasonId, setRequoteReasonId] = useState(null);

  const [showAlternative, setShowAlternative] = useState({
    loader: false, //loader for job details api
    techRepoLoader: false,
    timeLineLoader: false,
    error: "", //job details error
    techRepoError: "",
    timeLineError: "",
    feedbackError: "",
  });

  const [isOpen, setIsOpen] = useState({
    techinicalReport: false,
    changeTechnician: false,
    uploadJobFiles: false,
    jobLogs: false,
    axLogs: false,
    sendQuotation: false,
    jobWarranty: false,
    continueJob: false,
    rescheduleJob: false,
    sparePartsSelection: false,
    serviceSelection: false,
    applyDiscount: false,
    acceptQuotation: false,
    paymentTerm: 0,
  });
  const [quotationId, setQuotationId] = useState(null);
  const [selectedParts, setSelectedParts] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [quotationListState, setQuotationListState] = useState({
    loader: false,
    error: "",
    noRecords: false,
  });
  const [quotationSummary, setQuotationSummary] = useState(null);
  const dispatch = useDispatch();
  const quotationStore = useSelector((state) => state.quotation.quotationList);

  const [inputs, setInputs] = useState({
    rejectReason: "",
  });
  const [isDownloading, setIsDownloading] = useState(false);
  const [isAPiProcessing, setIsAPiProcessing] = useState(false);
  const [isSaveClicked, setIsSaveClicked] = useState(false);

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  useEffect(() => {
    if (decodedId && activeTab === "overview") {
      getJobDetails(decodedId);
      timeLineDetails(decodedId);
      technicalReportDetails(decodedId);
      feedbackDetails(decodedId);
    }

    if (activeTab === "quotation" || activeTab === "payments") {
      refreshQuotationData();
    }
  }, [decodedId, activeTab]);

  useEffect(() => {
    const res = quotationStore;
    if (!res) return;

    if (res.code !== 200) {
      setQuotationListState({
        loader: false,
        error: res?.message || "Failed to fetch quotation list",
        noRecords: false,
      });
      return;
    }

    const quotation = res?.data || null;
    const spareParts = res?.data?.quotationItems?.spareParts || [];
    const services = res?.data?.quotationItems?.services || [];

    // ✅ Always set quotationId when API returns an ID
    if (quotation?.ID) {
      setQuotationId(quotation.ID);
    }

    setQuotationSummary(quotation);

    if (!spareParts.length && !services.length) {
      setQuotationListState({
        loader: false,
        error: "",
        noRecords: true,
      });
      return;
    }

    setSelectedParts(spareParts);
    setSelectedServices(services);

    setQuotationListState({
      loader: false,
      error: "",
      noRecords: false,
    });
  }, [quotationStore]);

  useEffect(() => {
    setQuotationId(null);
    setSelectedParts([]);
    setSelectedServices([]);
    setQuotationSummary(null);
  }, [decodedId]);

  const convertTimeline = (backendList) => {
    return backendList.map((item) => {
      const ui = TIMELINE_UI_MAP[item.status] || TIMELINE_UI_MAP.DEFAULT;

      return {
        date: item.date ? item.date : "-",
        event: toTitleCase(item.description),
        icon: ui.icon,
        color: ui.color,
      };
    });
  };

  const technicalReportDetails = async (id) => {
    try {
      setShowAlternative((prev) => ({
        ...prev,
        techRepoLoader: true,
        techRepoError: false,
      }));
      const res = await getTechnicalReportByID(id);
      if (res.code === 200) {
        const technicalReportRes = res?.data;
        setTechRepoFormData({
          ID: { value: technicalReportRes?.ID || "", error: "" },
          jobID: { value: technicalReportRes?.jobID || "", error: "" },
          technicianID: {
            value: technicalReportRes?.technicianID?.ID || "",
            label: technicalReportRes?.technicianID?.name || "",
            error: "",
          },
          serialNo: { value: technicalReportRes?.serialNo || "", error: "" },
          causeOfFailure: {
            value: technicalReportRes?.causeOfFailure || "",
            error: "",
          },
          additionalInfo: {
            value: technicalReportRes?.additionalInfo || "",
            error: "",
          },
          otherFinding: {
            value: technicalReportRes?.otherFinding || "",
            error: "",
          },
          media: technicalReportRes?.tecnicalReportMedia || [],
        });

        setShowAlternative((prev) => ({
          ...prev,
          techRepoLoader: false,
          techRepoError: false,
        }));
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Failed to load spare part details!";
        setShowAlternative((prev) => ({
          ...prev,
          techRepoLoader: false,
          techRepoError: message,
        }));
      }
    } catch (error) {
      setShowAlternative((prev) => ({
        ...prev,
        techRepoLoader: false,
        techRepoError: error || "Failed to load timeline!",
      }));
    }
  };

  const feedbackDetails = async (id) => {
    try {
      setShowAlternative((prev) => ({
        ...prev,
        loader: true,
        feedbackError: false,
      }));

      const filtersJSON = JSON.stringify([
        {
          field: "JobID",
          condition: "eq",
          filterValues: [String(id)],
        },
      ]);

      const res = await getFeedbackByID(id);

      if (res.code === 200) {
        setFeedback(res.data || {});
        setShowAlternative((prev) => ({
          ...prev,
          loader: false,
          feedbackError: false,
        }));
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || `Failed to load ${SMALL_CASE_WORK_ORDER} feedback!`;

        setShowAlternative((prev) => ({
          ...prev,
          loader: false,
          feedbackError: message,
        }));
      }
    } catch (error) {
      setShowAlternative((prev) => ({
        ...prev,
        loader: false,
        feedbackError:
          error || `Failed to load ${SMALL_CASE_WORK_ORDER} feedback!`,
      }));
    }
  };

  const timeLineDetails = async (id) => {
    try {
      setShowAlternative((prev) => ({
        ...prev,
        timeLineLoader: true,
        timeLineError: false,
      }));
      const res = await getJobTimeLineByID(id);

      if (res.code === 200) {
        const formattedList = convertTimeline(res.data.jobTimeLine || []);
        setTimeline(formattedList);
        setShowAlternative((prev) => ({
          ...prev,
          timeLineLoader: false,
          timeLineError: false,
        }));
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Failed to load timeline!";
        setShowAlternative((prev) => ({
          ...prev,
          timeLineLoader: false,
          timeLineError: message,
        }));
      }
    } catch (error) {
      setShowAlternative((prev) => ({
        ...prev,
        timeLineLoader: false,
        timeLineError: error || "Failed to load timeline!",
      }));
    }
  };

  const getJobDetails = async (jobId) => {
    try {
      setShowAlternative((prev) => ({ ...prev, loader: true, error: false }));
      const res = await getJobByID(jobId);

      if (res.code === 200) {
        const jobDetailsRes = res?.data;

        setJobFormData({
          // basic ids / labels
          customer: {
            value: jobDetailsRes.customer?.ID || "",
            label: jobDetailsRes.customer?.name || "",
            phone: jobDetailsRes.customer?.phone || "",
            email: jobDetailsRes.customer?.email || "",
            address: jobDetailsRes.customer?.address || "",
          },
          customerLocation: {
            value: jobDetailsRes.customerLocation?.ID || "",
            label: jobDetailsRes.customerLocation?.regionResponce?.name || "",
            address: jobDetailsRes.customerLocation?.address || "",
            outletName: jobDetailsRes.customerLocation?.outletName || "",
            contactPersonName:
              jobDetailsRes.customerLocation?.contactPersonName || "",
            contactPersonPhone:
              jobDetailsRes.customerLocation?.contactPersonPhone || "",
            contactEmail: jobDetailsRes.customerLocation?.contactEmail || "",
            alternateContactPersonName:
              jobDetailsRes.customerLocation?.alternateContactPersonName || "",
            alternateContactPersonPhone:
              jobDetailsRes.customerLocation?.alternateContactPersonPhone || "",
            alternateContactEmail:
              jobDetailsRes.customerLocation?.alternateContactEmail || "",
            regionID: jobDetailsRes.customerLocation?.regionResponce?.ID || "",
            companyName: jobDetailsRes.customerLocation?.companyName || "",
          },
          customerEquipment: {
            value: jobDetailsRes.customerEquipment?.ID || "",
            serialNo: jobDetailsRes.customerEquipment?.serialNo || "",
            assetTag: jobDetailsRes.customerEquipment?.assetTag || "",
            invoicePath: jobDetailsRes.customerEquipment?.invoicePath || "",
            seller: jobDetailsRes.customerEquipment?.seller || "",
            status: jobDetailsRes.customerEquipment?.status || "",
            underWarranty: jobDetailsRes.customerEquipment?.underWarranty || "",
          },

          // job type / technician
          jobTypeID: {
            value: jobDetailsRes.jobTypeID?.ID || "",
            label: jobDetailsRes.jobTypeID?.name || "",
          },
          technician: {
            value: jobDetailsRes.technician?.ID || "",
            label: jobDetailsRes.technician?.name || "",
          },

          // manufacturer / product
          manufacturer: {
            value: jobDetailsRes.manufacturer?.ID || "",
            label: jobDetailsRes.manufacturer?.name || "",
          },
          product: {
            value: jobDetailsRes.product?.ID || "",
            label: jobDetailsRes.product?.name || "",
            modelNo: jobDetailsRes.product?.modelNo || "",
          },

          // schedule & reasons
          scheduledFrom: jobDetailsRes.scheduledFrom || "",
          scheduledTo: jobDetailsRes.scheduledTo || "",
          rescheduleReason: jobDetailsRes.rescheduleReason || "",
          cancelledReason: jobDetailsRes.cancelledReason || "",
          underWarranty: jobDetailsRes.underWarranty || "",

          // identifiers / reference numbers
          jobReferenceNo: { value: jobDetailsRes.jobReferenceNo || "" },
          error: "",
          jobSalesOrderNo: jobDetailsRes.jobSalesOrderNo || "",
          partsPurchaseOrderNo: jobDetailsRes.partsPurchaseOrderNo || "",

          // notes
          clientNote: jobDetailsRes.clientNote || "",
          adminNote: { value: jobDetailsRes.adminNote || "" },
          error: "",
          partsNote: jobDetailsRes.partsNote || "",
          warrantyNote: jobDetailsRes.warrantyNote || "",

          //purchaseDate
          purchaseDate: jobDetailsRes.purchaseDate || "",

          // part request fields
          partRequestedReceivedOn: jobDetailsRes.partRequestedReceivedOn || "",
          partRequestedEtaDate: jobDetailsRes.partRequestedEtaDate || "",
          partRequestedStatus: jobDetailsRes.partRequestedStatus || "",

          // priority / status / metadata
          priority: jobDetailsRes.priority || "",
          jobStatus: jobDetailsRes.jobStatus || "",
          createdByID: jobDetailsRes.createdByID || "",
          completedOn: jobDetailsRes.completedOn || "",
          jobSchedules: jobDetailsRes.jobSchedules || [],
          paymentTerm: {
            ID: jobDetailsRes?.paymentTerm?.ID,
            term: jobDetailsRes?.paymentTerm?.term,
          },
          internalTrackingFlag: jobDetailsRes.internalTrackingFlag || "NO"
        });
        setEditableData((prev) => ({
          ...prev,
          notes: { ...prev, value: jobDetailsRes.adminNote },
          jobSalesOrderNo: { ...prev, value: jobDetailsRes.jobSalesOrderNo },
        }));

        setShowAlternative((prev) => ({
          ...prev,
          loader: false,
          error: false,
        }));
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Failed to load spare part details!";
        setShowAlternative((prev) => ({
          ...prev,
          loader: false,
          error: message,
        }));
      }
    } catch (error) {
      setShowAlternative((prev) => ({
        ...prev,
        loader: false,
        error: error || "Failed to load spare part details!",
      }));
    }
  };

  const handleTechnicianUpdated = async () => {
    await getJobDetails(decodedId);
    await timeLineDetails(decodedId);
  };

  const sampleData = {
    id: "JOB-12345",
    title: "AC Installation and Maintenance",
    client: "John Doe",
    customer: "John Doe (JD Enterprises)",
    status: "In Progress",
    priority: "High",
    job: {
      status: "Parts Requested",
      referenceNo: "REF-78910",
      poNo: "PO-56432",
      salesOrderNo: "SO-10293",
      warranty: "No",
      belongsTo: "",
      type: "Regular Maintenance",
    },
    product: {
      manufacturer: "CookMaster",
      productName: "Pressure Cooker Pro",
      model: "AR18TXFYAWK",
      serialNo: "SN-2025-8745",
      warranty: "No",
      assetTag: "",
      seller: "Falcon",
      purchaseDate: "11 Oct 2025",
      purchaseInvoice: "",
    },
    problemByClient: "AC not cooling properly, unusual noise while operating.",
    quotation: {
      amount: "SAR 2,500",
      currency: "SAR",
      status: "Approved",
      updated: "08 Oct 2025",
      history: [
        {
          version: "V1",
          date: "07 Oct 2025",
          status: "Pending Approval",
        },
        {
          version: "V2",
          date: "08 Oct 2025",
          status: "Approved",
        },
      ],
    },
    coordinatorNote: {
      notes:
        "Client requested morning visit between 9–11 AM. Technician confirmed availability.",
      by: "Coordinator Sarah Ali",
      date: "12 Oct 2025",
    },
    schedule: [
      {
        day: "Day 1",
        startAt: "12 Oct 2025 02:00 PM",
        endAt: "12 Oct 2025 04:30 PM",
      },
    ],
    technicalReport: {
      technician: "Ahmed Khan",
      serialNo: "SN-2025-8745",
      findings: "Low refrigerant pressure detected.",
      causeOfFailure: "Compressor leak due to loose fitting.",
      additionalInfo:
        "Replacement part ordered. Expected delivery by 16 Oct 2025.",
      observations: "Compressor faulty, needs replacement.",
      notes: "Parts ordered, installation scheduled for 18 Oct 2025.",
    },
    timeline: [
      {
        date: "05 Oct 2025",
        event: "Service Reported By Ehab Eyad",
        icon: "icon-badge",
        color: "secondary",
      },
      {
        date: "06 Oct 2025",
        event: "Job Allocated to Ahmed Khan",
        icon: "icon-single-02",
        color: "info",
      },
      {
        date: "07 Oct 2025",
        event: "Quotation Inprogress",
        icon: "icon-notes",
        color: "warning",
      },
      {
        date: "08 Oct 2025",
        event: "Quotation Sent",
        icon: "icon-notes",
        color: "warning",
      },
      {
        date: "09 Oct 2025",
        event: "Quotation Approved And Payment Received",
        icon: "icon-check-2",
        color: "success",
      },
      {
        date: "10 Oct 2025",
        event: "Parts Ordered",
        icon: "icon-cart",
        color: "warning",
      },
      {
        date: "12 Oct 2025",
        event: "Repair",
        icon: "icon-settings",
        color: "info",
      },
      {
        date: "12 Oct 2025",
        event: "Repaired",
        icon: "icon-check-2",
        color: "success",
      },
      // {
      //   date: "13 Oct 2025",
      //   event: "Invoice Paid",
      //   icon: "icon-money-coins",
      //   color: "success",
      // },
    ],
    feedback: {
      date: "13 Oct 2025 05:55 PM",
      rating: "4.5",
      reason: "",
      comment: "",
    },
    paymentDetails: {
      paymentMethod: "Credit",
      transactionID: "STCPAY-TRX-10234567",
      paymentStatus: "Paid",
      amount: "2500",
      paymentdate: "13 Oct 2025 04:56 PM",
    },
    quotationHistory: [
      {
        quotationID: "170907",
        date: "07 Oct 2025 12:12 PM",
        pdf: "",
      },
      {
        quotationID: "170907",
        date: "07 Oct 2025 07:36 PM",
        pdf: "",
      },
    ],
    equipmentManual: [
      {
        ID: 1,
        title: "ROCKET_R NINE ONE PARTS CATALOGUE JULY.PDF",
        pdf: "",
      },
      {
        ID: 2,
        title: "ROCKET_R NINE ONE USER MANUAL.PDF",
        pdf: "",
      },
    ],
    clientMedia: {
      images: [
        {
          ID: 1,
          url: require("../../assets/img/Dishwashers_sample_img_3.jpeg"),
        },
      ],
    },
    technicianMedia: {
      images: [
        { ID: 1, url: require("../../assets/img/Dishwashers_sample_img.jpg") },
        { ID: 2, url: require("../../assets/img/Dishwasher_sample_img_2.jpg") },
      ],
    },
    adminMedia: {
      images: [
        { ID: 1, url: require("../../assets/img/product-sample-img.jpeg") },
      ],
      documents: [
        {
          ID: 1,
          title: "Sample Pdf",
          url: require("../../assets/samplePDF/file-sample_150kB.pdf"),
          name: "product-specification.pdf",
        },
      ],
    },
    quotationData: {
      status: "ACCEPTED",
      items: [
        {
          description: "HeatWave - Cooktop Knob",
          itemNumber: "SP-1007",
          quantity: 1,
          unitPrice: "SAR 500.00",
          discount: "SAR 0.00 (0.00%)",
          amount: "SAR 500.00",
        },
        {
          description: "CrispyChef- Air Fryer Basket",
          itemNumber: "SP-1014",
          quantity: 1,
          unitPrice: "SAR 65.00",
          discount: "SAR 0.00 (0.00%)",
          amount: "SAR 65.00",
        },
        {
          description: "Alshaya–Compressor Replacement",
          itemNumber: "-",
          quantity: 1,
          unitPrice: "SAR 650.00",
          discount: "SAR 0.00 (0.00%)",
          amount: "SAR 650.00",
        },
      ],

      sparePartsCharges: "SAR 565.00",
      serviceCharge: "SAR 650.00",
      subtotal: "SAR 1215.00",
      discount: "5.00 %",
      discountAmount: "SAR 60.75",
      afterDiscount: "SAR 1154.25",
      vat: "SAR 173.14",
      total: "SAR 1327.39",
      grandtotal: "SAR 1327.39",
    },
  };

  const [editableData, setEditableData] = useState({
    referenceNo: jobFormData.jobReferenceNo.value,
    poNo: sampleData?.job?.poNo,
    notes: { value: jobFormData.adminNote.value, error: "" },
    jobSalesOrderNo: { value: jobFormData.jobSalesOrderNo, error: "" },
  });
  const [showDetails, setShowDetails] = useState(false);
  const rejectReasonRef = useRef("");
  const cancelReasonRef = useRef("");
  const bankTransferNoteRef = useRef("");

  const handleEdit = (key) => {
    setIsEditing((prev) => ({
      ...prev,
      [key]: { edit: true, value: editableData[key].value },
    }));
  };

  const handleClose = (key) => {
    setEditableData((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        error: "",
      },
    }));

    setIsEditing((prev) => ({
      ...prev,
      [key]: { edit: false, value: "" },
    }));
  };

  const handleSave = async (key) => {
    if (!isEditing[key]?.value?.trim()) {
      setEditableData((prev) => ({
        ...prev,
        [key]: {
          ...prev[key],
          error:
            key === "notes"
              ? "Admin note is required"
              : "Sales order number is required",
        },
      }));
      return;
    }
    if (key === "notes") {
      try {
        let payload = {
          adminNote: isEditing[key].value,
        };
        const res = await updateAdminNote(decodedId, payload);
        if (res?.code !== 200) {
          notify("danger", res?.message || "Failed to update admin note");
          return;
        }

        notify("success", res?.message || "Admin Note Updated Successfuly");
        await getJobDetails(decodedId);
      } catch (error) {
        notify("danger", "Something went wrong");
      } finally {
        // setEditableData((prev) => ({
        //   ...prev,
        //   [key]: isEditing[key].value,
        // }));
        setIsEditing((prev) => ({
          ...prev,
          [key]: { edit: false, value: "" },
        }));
      }
    }

    if (key === "jobSalesOrderNo") {
      try {
        let payload = {
          jobSalesOrderNo: isEditing[key].value,
        };
        const res = await updateSalesOrderNumber(decodedId, payload);
        if (res?.code !== 200) {
          notify(
            "danger",
            res?.message ||
            `Failed to update ${SMALL_CASE_WORK_ORDER} sales order number.`,
          );
          return;
        }

        notify(
          "success",
          res?.message ||
          `${WORK_ORDER} Sales Order Number Updated Successfuly`,
        );
        await getJobDetails(decodedId);
      } catch (error) {
        notify("danger", "Something went wrong");
      } finally {
        // setEditableData((prev) => ({
        //   ...prev,
        //   [key]: isEditing[key].value,
        // }));
        setIsEditing((prev) => ({
          ...prev,
          [key]: { edit: false, value: "" },
        }));
      }
    }
  };

  const handleChange = (key, value) => {
    setIsEditing((prev) => ({
      ...prev,
      [key]: { ...prev[key], value },
    }));

    setEditableData((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        value,
        error: "",
      },
    }));
  };

  const handleBlurValidation = (key) => {
    if (!isEditing[key]?.value?.trim()) {
      setEditableData((prev) => ({
        ...prev,
        [key]: {
          ...prev[key],
          error:
            key === "notes"
              ? "Admin note is required"
              : `Sales order number is required`,
        },
      }));
      return;
    }

    setEditableData((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        error: "",
      },
    }));
  };

  const notify = (type, message) => {
    let finalMessage = message;

    if (Array.isArray(message)) {
      finalMessage = message[0]?.Msg || "Something went wrong";
    } else if (typeof message === "object") {
      finalMessage = message?.Msg || "Something went wrong";
    }
    const options = {
      place: "tr",
      message: <div>{finalMessage}</div>,
      type,
      icon: "tim-icons icon-bell-55",
      autoDismiss: 5,
    };
    notificationAlertRef?.current?.notificationAlert(options);
  };

  const toggleModal = (modalName, value = false) => {
    setIsOpen({
      techinicalReport: false,
      changeTechnician: false,
      uploadJobFiles: false,
      jobLogs: false,
      axLogs: false,
      sendQuotation: false,
      jobWarranty: false,
      continueJob: false,
      rescheduleJob: false,
      sparePartsSelection: false,
      serviceSelection: false,
      applyDiscount: false,
      acceptQuotation: false,
      paymentTerm: 0,
      [modalName]: value,
    });
  };

  // close all modals
  const handleCloseModal = () => {
    toggleModal("");
  };

  // open modal based on type
  const handleOpenModal = (type, paymentTerm = 0) => {
    toggleModal(type, true, paymentTerm);
  };

  const downloadJobReport = async () => {
    setIsDownloading(true);
    try {
      const res = await downloadJobReportByJobId(decodedId);
      if (res.status === 200 && res.data) {
        const fileName =
          res.headers["content-disposition"]?.match(/filename="(.+?)"/)?.[1] ||
          `job_${decodedId}.pdf`;

        const blob = new Blob([res.data], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(url);
      } else if (res.code === 404) {
        notify(
          "danger",
          `The ${SMALL_CASE_WORK_ORDER} report not found. Please try again.`,
        );
      } else {
        notify(
          "danger",
          res?.message ||
          `Failed to download ${SMALL_CASE_WORK_ORDER} report. Please try again.`,
        );
      }
    } catch (error) {
      notify(
        "danger",
        error?.message ||
        `Failed to download ${SMALL_CASE_WORK_ORDER} report. Please try again.`,
      );
    }
    setIsDownloading(false);
  };

  const handleContinueJob = async (payload) => {
    try {
      setIsSaveClicked(true);
      const res = await updateJobToContinue(decodedId, payload);
      if (res?.code !== 200) {
        notify(
          "danger",
          res?.message || `Failed to update ${SMALL_CASE_WORK_ORDER} status`,
        );
        return;
      }

      notify(
        "success",
        res?.message || `${WORK_ORDER} Status Updated Successfuly`,
      );
      await fetchQuotationList();
      await getJobDetails(decodedId);
      await timeLineDetails(decodedId);
      handleCloseModal();
    } catch (error) {
      notify("danger", error?.message || "Something Went Wrong");
    } finally {
      setIsSaveClicked(false);
    }
  };

  const downloadEquipmentManual = async (productDocumentID) => {
    setIsDownloading(true);
    try {
      const res = await downloadProductManual(productDocumentID, "document");
      if (res.status === 200 && res.data) {
        const fileName =
          res.headers["content-disposition"]?.match(/filename="(.+?)"/)?.[1];
        const url = URL.createObjectURL(res.data);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(url);
      } else if (res.code === 404) {
        notify("danger", res?.message || "Manual not found.");
      } else {
        notify(
          "danger",
          res?.message || "Failed to download manual. Please try again.",
        );
      }
    } catch (error) {
      notify(
        "danger",
        error?.message || "Failed to download manual. Please try again.",
      );
    }
    setIsDownloading(false);
  };

  const downloadInvoice = async (productDocumentID) => {
    setIsDownloading(true);
    try {
      const res = await downloadEquipmentInvoice(productDocumentID);
      if (res.status === 200 && res.data) {
        const fileName =
          res.headers["content-disposition"]?.match(/filename="(.+?)"/)?.[1];
        const url = URL.createObjectURL(res.data);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(url);
      } else if (res.code === 404) {
        notify("danger", res?.message || "Invoice not found.");
      } else {
        notify(
          "danger",
          res?.message || "Failed to download invoice. Please try again.",
        );
      }
    } catch (error) {
      notify(
        "danger",
        error?.message || "Failed to download invoice. Please try again.",
      );
    }
    setIsDownloading(false);
  };

  // download files based on type
  const handleFileDownload = (type, id) => {
    switch (type) {
      case "job_report":
        downloadJobReport();
        return;

      case "equipment_manual":
        downloadEquipmentManual(id);
        break;

      case "quotation":
        return downloadQuotationHistoryFile(id);

      case "invoice":
        downloadInvoice(id);
        break;

      default:
        return;
    }
  };

  const downloadQuotationHistoryFile = async (item) => {
    setIsDownloading(true);
    try {
      const res = await downloadQuotationHistory(item?.quotationID || item);

      if (res.status === 200 && res.data) {
        const version = item?.version ?? quotationStore?.data?.version ?? "0";
        const baseName =
          version !== 0
            ? `quotation-${decodedId}-${version}`
            : `quotation-${decodedId}`;
        const fileName =
          res.headers["content-disposition"]?.match(/filename="(.+?)"/)?.[1] ||
          `${baseName}.pdf`;
        const blob = new Blob([res.data], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(url);
        showAlert({
          type: "success",
          title: "Download Successful",
          message: <span>Quotation downloaded successfully.</span>,
          showCancel: false,
          confirmText: "OK",
          confirmStyle: "success",
        });
      } else {
        showAlert({
          type: "warning",
          title: "Download Failed",
          message: "no file found.",
          showCancel: false,
          confirmText: "OK",
        });
      }
    } catch (err) {
      showAlert({
        type: "warning",
        title: "Download Failed",
        message: "no file found",
        showCancel: false,
        confirmText: "OK",
      });
    }
    setIsDownloading(false);
  };

  const handleCommonInputs = (key, value) => {
    setInputs((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const completeOrReworkJob = async (status) => {
    setIsAPiProcessing(true);
    try {
      let payload = {
        JobStatus: status,
      };
      const res = await updateJobStatus(decodedId, payload);
      if (res?.code !== 200) {
        notify(
          "danger",
          res?.message || `Failed to update ${SMALL_CASE_WORK_ORDER} status`,
        );
        return;
      }

      notify(
        "success",
        res?.message || `${WORK_ORDER} status updated successfully.`,
      );

      await fetchQuotationList();
      await getJobDetails(decodedId);
      await timeLineDetails(decodedId);
    } catch (error) {
      notify("danger", "Something went wrong");
    } finally {
      setIsAPiProcessing(false);
    }
  };

  const handleRecordBankTransfer = async () => {
    const note = bankTransferNoteRef.current;

    if (!note) {
      notify("danger", "Please enter a note for the bank transfer.");
      return;
    }
    setIsAPiProcessing(true);
    try {
      const payload = {
        recordBankTransfer: note,
      };
      const res = await recordBankTransfer(decodedId, payload);

      if (res?.code !== 200) {
        notify("danger", res?.message || "Failed to record bank transfer");
        return;
      }

      notify("success", res?.message || "Bank transfer recorded successfully");

      await getJobDetails(decodedId);
      await timeLineDetails(decodedId);
    } catch (error) {
      notify("danger", error?.message || "Something went wrong");
    } finally {
      setIsAPiProcessing(false);
    }
  };

  const handleReopenJob = async () => {
    setIsAPiProcessing(true);
    try {
      const res = await reopenJob(decodedId);
      if (res?.code !== 200) {
        notify(
          "danger",
          res?.message || `Failed to reopen ${SMALL_CASE_WORK_ORDER}`,
        );
        return;
      }

      notify("success", res?.message || `${WORK_ORDER} reopened successfully.`);

      await fetchQuotationList();
      await getJobDetails(decodedId);
      await timeLineDetails(decodedId);
    } catch (error) {
      notify("danger", "Something went wrong");
    } finally {
      setIsAPiProcessing(false);
    }
  };

  // show confirmation alerts based on action type
  const handleConfirmationAlerts = (type) => {
    switch (type) {
      case "cancel_job":
        return showAlert({
          title: `Are you sure you want to cancel this ${SMALL_CASE_WORK_ORDER}?`,
          type: "warning",
          message:
            "This action cannot be undone. Please provide a reason for cancellation:",
          confirmStyle: "danger",
          cancelStyle: "secondary",
          confirmText: "Yes, Cancel",
          cancelText: "No",
          onConfirm: () => handleCancelJob(),
          onCancel: () => { },
          children: (
            <FormGroup className="mt-2 d-flex flex-column align-items-start">
              <Input
                name="reason"
                type="textarea"
                placeholder="Enter reason *"
                onChange={(e) => {
                  cancelReasonRef.current = e.target.value;
                }}
              />
            </FormGroup>
          ),
        });

      case "reject_quotation":
        return showAlert({
          title: "Are you sure you want to reject this quotation?",
          type: "warning",
          message:
            "This action cannot be undone. Please provide a reason for rejection.",
          confirmStyle: "danger",
          cancelStyle: "secondary",
          confirmText: "Yes, Reject",
          cancelText: "No",
          // onConfirm: () => {},
          onConfirm: () => handleRejctQuotation(),
          onCancel: () => { },
          children: (
            <FormGroup className="mt-2 d-flex flex-column align-items-start">
              <Input
                name="rejectReason"
                type="textarea"
                placeholder="Enter reason *"
                // value={inputs.rejectReason}
                // onChange={(e) => {
                //   e.stopPropagation();
                //   handleCommonInputs("rejectReason", e.target.value);
                // }}
                onChange={(e) => {
                  rejectReasonRef.current = e.target.value;
                }}
              />
            </FormGroup>
          ),
        });

      case "quotation_ready":
        return showAlert({
          title:
            "Are you sure you want to mark this quotation as ready for customer review?",
          type: "warning",
          message:
            "Please confirm that the quotation is ready to be shared with the customer for review and approval.",
          confirmStyle: "default",
          cancelStyle: "secondary",
          confirmText: "Yes, Confirm",
          cancelText: "Cancel",
          onConfirm: handleQuotationReady,
          onCancel: () => { },
        });

      case "review_work_done":
        return showAlert({
          title: "Confirmation of Work Done",
          type: "warning",
          message:
            "Please confirm whether the work completed on behalf of the customer should be approved or reopened.",
          confirmStyle: "default",
          cancelStyle: "secondary",
          confirmText: "Approve",
          cancelText: "Reopen",
          onConfirm: () => completeOrReworkJob("COMPLETED"),
          onCancel: () => completeOrReworkJob("REWORK_REQUIRED"),
        });

      case "complete_job":
        return showAlert({
          title: `Are you sure you want to mark this ${SMALL_CASE_WORK_ORDER} as completed?`,
          type: "warning",
          message: `Please confirm that the ${SMALL_CASE_WORK_ORDER} has been completed. The ${SMALL_CASE_WORK_ORDER} status will be updated to ‘Repaired’.`,
          confirmStyle: "default",
          cancelStyle: "secondary",
          confirmText: "Yes, Confirm",
          cancelText: "No",
          onConfirm: () => handleCompleteJob(),
          onCancel: () => { },
        });

      case "bank_transfer":
        return showAlert({
          title: "Record Bank Transfer",
          type: "info",
          message: `Please enter a note or reference for the bank transfer received for this ${SMALL_CASE_WORK_ORDER}.`,
          confirmStyle: "default",
          cancelStyle: "secondary",
          confirmText: "Save",
          cancelText: "Cancel",
          onConfirm: () => handleRecordBankTransfer(),
          onCancel: () => { },
          children: (
            <FormGroup className="mt-2 d-flex flex-column align-items-start">
              <Input
                name="note"
                type="textarea"
                placeholder="Enter note or reference"
                onChange={(e) => {
                  bankTransferNoteRef.current = e.target.value;
                }}
              />
            </FormGroup>
          ),
        });

      case "accept_quotation":
        return showAlert({
          title: "Are you sure you want to accept this quotation?",
          type: "warning",
          message: "This action cannot be undone. Please confirm to continue.",
          confirmStyle: "default",
          cancelStyle: "secondary",
          confirmText: "Yes, Accept",
          cancelText: "No",
          onConfirm: () => { },
          onCancel: () => { },
        });
      case "rework_job":
        return showAlert({
          title: `Re-Work ${WORK_ORDER}`,
          type: "warning",
          message: `Are you sure you want to send this ${WORK_ORDER} for re-work? This will move the ${WORK_ORDER} back for further repair.`,
          confirmText: "Yes, Re-Work",
          cancelText: "Cancel",
          confirmStyle: "danger",
          cancelStyle: "secondary",
          onConfirm: () => { },
          onCancel: () => { },
          children: (
            <FormGroup className="mt-2 d-flex flex-column align-items-start">
              <Input name="reason" type="textarea" placeholder="Enter reason" />
            </FormGroup>
          ),
        });

      case "reopen_job":
        return showAlert({
          title: `Are you sure you want to reopen this ${SMALL_CASE_WORK_ORDER}?`,
          type: "warning",
          message: "This action cannot be undone. Please confirm to continue.",
          confirmStyle: "default",
          cancelStyle: "secondary",
          confirmText: "Yes, Reopen",
          cancelText: "No",
          onConfirm: () => handleReopenJob(),
          onCancel: () => { },
        });

      default:
        return;
    }
  };

  const fetchQuotationList = async () => {
    setQuotationListState({
      loader: true,
      error: "",
      noRecords: false,
    });

    await getQuotationList(dispatch, decodedId);
    await getPaymentDetails(dispatch, decodedId);
    await getJobQuotationHistory(dispatch, decodedId);
  };

  const refreshHistoryList = () => { };

  const refreshQuotationData = async () => {
    if (!decodedId) return;

    try {
      await Promise.all([
        getQuotationList(dispatch, decodedId),
        getPaymentDetails(dispatch, decodedId),
        getJobQuotationHistory(dispatch, decodedId),
        getJobDetails(decodedId),
        timeLineDetails(decodedId),
      ]);
    } catch (error) {
      console.error("Error refreshing quotation data:", error);
    }
  };


  const saveQuotation = async (parts, services) => {
    // ✅ Fallback: read latest quotation ID directly from store if state is stale
    const effectiveQuotationId =
      quotationId ||
      quotationStore?.data?.ID ||
      quotationStore?.data?.quotationID ||
      null;

    const body = { jobID: decodedId };
    const isEdit = Boolean(effectiveQuotationId);

    if (Array.isArray(parts) && parts.length > 0) {
      body.spareParts = parts.map((part) => ({
        ID: part.itemID ?? part.ID,
        quantity: part.quantity,
      }));
    }

    if (Array.isArray(services) && services.length > 0) {
      body.serviceIDs = services.map((service) =>
        typeof service === "object" ? (service.itemID ?? service.ID) : service,
      );
    }

    try {
      let res;
      setIsSaveClicked(true);

      if (
        isEdit &&
        (jobFormData.jobStatus === "REQUEST_APPROVAL" ||
          jobFormData.jobStatus === "REPAIR" ||
          jobFormData.jobStatus === "PART_REQUESTS")
      ) {
        Object.assign(body, { requoteReasonID: requoteReasonId });
        res = await quotationRequote(body);
      } else if (isEdit && jobFormData.jobStatus !== "QUOTATION_REJECTED") {
        // ✅ Use effectiveQuotationId, not quotationId
        res = await editQuotation(effectiveQuotationId, decodedId, body);
      } else {
        if (!body.spareParts) delete body.spareParts;
        if (!body.serviceIDs) delete body.serviceIDs;

        res = await addQuotation(body);

        if (res?.code === 200) {
          const newId = res?.data?.quotation?.ID;
          if (newId) {
            setQuotationId(newId);
          }
          setRequoteReasonId(null);
        }
      }

      if (res?.code !== 200) {
        const message = Array.isArray(res?.message)
          ? res.message.map((item) => item?.Msg).filter(Boolean).join(", ")
          : res?.message || "Quotation save failed";
        notify("danger", message);
        return;
      }

      await fetchQuotationList();
      await getJobDetails(decodedId);
      await getJobQuotationHistory(dispatch, decodedId);
      await timeLineDetails(decodedId);
      await refreshQuotationData();
      notify("success", res?.message || "Quotation saved successfully");
    } catch (error) {
      notify("danger", "Something went wrong");
    } finally {
      setIsSaveClicked(false);
    }
  };

  const handleQuotationReady = async () => {
    if (!quotationId) {
      notify("warning", "Please create quotation before marking it ready");
      return;
    }

    const payload = {
      quotationID: quotationId,
      jobID: decodedId,
      // status: "QUOTATION_SENT",
    };
    setIsAPiProcessing(true);
    try {
      const res = await sendQuotation(payload);

      if (res?.code !== 200) {
        notify("danger", res?.message || "Failed to update quotation status");
        return;
      }

      notify(
        "success",
        res?.message || "Quotation Send to Customer Successfully",
      );

      await fetchQuotationList();
      await getJobDetails(decodedId);
      await timeLineDetails(decodedId);
    } catch (error) {
      notify("danger", "Something went wrong");
    } finally {
      setIsAPiProcessing(false);
    }
  };

  const handleRejctQuotation = async () => {
    const reason = rejectReasonRef.current;

    // if (!quotationId) {
    //   notify("warning", "Please create quotation before marking it ready");
    //   return;
    // }

    if (!reason) {
      notify("danger", "Please enter the reason for rejecting the quotation");
      return;
    }

    const payload = {
      quotationID: quotationId,
      jobID: decodedId,
      status: "QUOTATION_REJECTED",
      rejectionReason: reason,
    };

    setIsAPiProcessing(true);
    try {
      const res = await updateStatusQuotation(payload);

      if (res?.code !== 200) {
        notify("danger", res?.message || "Failed to update quotation status");
        return;
      }
      await refreshQuotationData();
      notify("success", res?.message || "Quotation Rejected Successfully.");

      setQuotationSummary(null);
      setSelectedParts([]);
      setQuotationId(null);
      await getJobDetails(decodedId);
      await timeLineDetails(decodedId);
    } catch (error) {
      notify("danger", "Something went wrong");
    } finally {
      setIsAPiProcessing(false);
    }
  };

  const handleCancelJob = async () => {
    const reason = cancelReasonRef.current;
    setIsAPiProcessing(true);
    try {
      const payLoad = {
        JobStatus: "CANCELLED",
        CancelledReason: reason,
      };

      const res = await cancelJobByJobId(decodedId, payLoad);

      if (res?.code !== 200) {
        notify(
          "danger",
          res?.message || `Failed to update ${SMALL_CASE_WORK_ORDER} status`,
        );
        return;
      }
      notify(
        "success",
        res?.message || `${WORK_ORDER} Cancelled Successfully.`,
      );
      await getJobDetails(decodedId);
      await timeLineDetails(decodedId);
    } catch (error) {
      notify("danger", "Something went wrong");
    } finally {
      setIsAPiProcessing(false);
    }
  };

  const handleCompleteJob = async () => {
    setIsAPiProcessing(true);
    try {
      const payLoad = {
        JobStatus: "REPAIRED",
      };

      const res = await completeJobByJobID(decodedId, payLoad);

      if (res?.code !== 200) {
        notify(
          "danger",
          res?.message || `Failed to update ${SMALL_CASE_WORK_ORDER} status`,
        );
        return;
      }
      notify(
        "success",
        res?.message || `${WORK_ORDER} Status Updated Successfully.`,
      );
      await getJobDetails(decodedId);
      await timeLineDetails(decodedId);
    } catch (error) {
      notify("danger", "Something went wrong");
    } finally {
      setIsAPiProcessing(false);
    }
  };

  const handleApprovedQuotation = async (formValues) => {
    if (!quotationId) {
      notify("warning", "Please create quotation before marking it ready");
      return;
    }
    const payload = {
      quotationID: quotationId,
      jobID: decodedId,
      status: "QUOTATION_APPROVED",
      ApprovalNote: formValues?.reason,
      isPaymentReceived: formValues?.paymentReceived,
      paymentTerm: formValues?.paymentTerm === 1 ? "CASH" : "CREDIT",
    };
    setIsSaveClicked(true);
    try {
      const res = await updateStatusQuotation(payload);

      if (res?.code !== 200) {
        notify("danger", res?.message || "Failed to update quotation status");
        return;
      }

      notify("success", res?.message || "Quotation Approved Successfully.");

      await fetchQuotationList();
      await getJobDetails(decodedId);
      await timeLineDetails(decodedId);
      handleCloseModal();
    } catch (error) {
      notify("danger", "Something went wrong");
    } finally {
      setIsSaveClicked(false);
    }
  };

  // used to render job details screens actions based on job status
  const renderJobInfoActionBtns = () => {
    const status = jobFormData.jobStatus;

    switch (status) {
      case "JOB_ALLOCATED":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-file-alt"
              label={`${WORK_ORDER} logs`}
              onClick={() => handleOpenModal("jobLogs")}
            />
            <ActionButton
              icon="fa-download"
              label={`${WORK_ORDER} Report`}
              onClick={() => handleFileDownload("job_report")}
            />
            <ActionButton
              icon="fa-upload"
              label={`Upload ${WORK_ORDER} Files`}
              onClick={() => handleOpenModal("uploadJobFiles")}
            />
            <ActionButton
              icon="fa-shield"
              label={`${WORK_ORDER} Warranty`}
              onClick={() => handleOpenModal("jobWarranty")}
            />
            <ActionButton
              icon="fa-calendar-alt"
              label="Reschedule"
              onClick={() => handleOpenModal("rescheduleJob")}
            />
            <ActionButton
              color="secondary"
              icon="fa-close"
              label={`Cancel ${WORK_ORDER}`}
              onClick={() => handleConfirmationAlerts("cancel_job")}
            />
          </div>
        );

      case "REQUEST_APPROVAL":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-file-alt"
              label={`${WORK_ORDER} logs`}
              onClick={() => handleOpenModal("jobLogs")}
            />
            <ActionButton
              icon="fa-download"
              label={`${WORK_ORDER} Report`}
              onClick={() => handleFileDownload("job_report")}
            />
            <ActionButton
              icon="fa-upload"
              label={`Upload ${WORK_ORDER} Files`}
              onClick={() => handleOpenModal("uploadJobFiles")}
            />
            <ActionButton
              icon="fa-shield"
              label={`${WORK_ORDER} Warranty`}
              onClick={() => handleOpenModal("jobWarranty")}
            />
            <ActionButton
              icon="fa-hourglass-half"
              label={`Continue ${WORK_ORDER}`}
              onClick={() => handleOpenModal("continueJob")}
            />
            <ActionButton
              icon="fa-calendar-alt"
              label="Reschedule"
              onClick={() => handleOpenModal("rescheduleJob")}
            />
            <ActionButton
              color="secondary"
              icon="fa-close"
              label={`Cancel ${WORK_ORDER}`}
              onClick={() => handleConfirmationAlerts("cancel_job")}
            />
          </div>
        );

      case "QUOTATION_IN_PROGRESS":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-file-alt"
              label={`${WORK_ORDER} logs`}
              onClick={() => handleOpenModal("jobLogs")}
            />
            <ActionButton
              icon="fa-download"
              label={`${WORK_ORDER} Report`}
              onClick={() => handleFileDownload("job_report")}
            />
            <ActionButton
              icon="fa-upload"
              label={`Upload ${WORK_ORDER} Files`}
              onClick={() => handleOpenModal("uploadJobFiles")}
            />
            <ActionButton
              icon="fa-shield"
              label={`${WORK_ORDER} Warranty`}
              onClick={() => handleOpenModal("jobWarranty")}
            />
            <ActionButton
              icon="fa-hourglass-half"
              label={`Continue ${WORK_ORDER}`}
              onClick={() => handleOpenModal("continueJob")}
            />
            <ActionButton
              icon="fa-calendar-alt"
              label="Reschedule"
              onClick={() => handleOpenModal("rescheduleJob")}
            />
            <ActionButton
              color="secondary"
              icon="fa-close"
              label={`Cancel ${WORK_ORDER}`}
              onClick={() => handleConfirmationAlerts("cancel_job")}
            />
          </div>
        );

      case "QUOTATION_ACCEPTED":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-file-alt"
              label={`${WORK_ORDER} logs`}
              onClick={() => handleOpenModal("jobLogs")}
            />
            <ActionButton
              icon="fa-download"
              label={`${WORK_ORDER} Report`}
              onClick={() => handleFileDownload("job_report")}
            />
            <ActionButton
              icon="fa-upload"
              label={`Upload ${WORK_ORDER} Files`}
              onClick={() => handleOpenModal("uploadJobFiles")}
            />
            {/* <ActionButton
              icon="fa-shield"
              label={`${WORK_ORDER} Warranty`}
              onClick={() => handleOpenModal("jobWarranty")}
            /> */}
            <ActionButton
              icon="fa-hourglass-half"
              label={`Continue ${WORK_ORDER}`}
              onClick={() => handleOpenModal("continueJob")}
            />
            <ActionButton
              icon="fa-calendar-alt"
              label="Reschedule"
              onClick={() => handleOpenModal("rescheduleJob")}
            />
            <ActionButton
              color="secondary"
              icon="fa-close"
              label={`Cancel ${WORK_ORDER}`}
              onClick={() => handleConfirmationAlerts("cancel_job")}
            />
          </div>
        );

      case "QUOTATION_REJECTED":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-file-alt"
              label={`${WORK_ORDER} logs`}
              onClick={() => handleOpenModal("jobLogs")}
            />
            <ActionButton
              icon="fa-download"
              label={`${WORK_ORDER} Report`}
              onClick={() => handleFileDownload("job_report")}
            />
            <ActionButton
              icon="fa-upload"
              label={`Upload ${WORK_ORDER} Files`}
              onClick={() => handleOpenModal("uploadJobFiles")}
            />
            <ActionButton
              icon="fa-shield"
              label={`${WORK_ORDER} Warranty`}
              onClick={() => handleOpenModal("jobWarranty")}
            />
            <ActionButton
              icon="fa-hourglass-half"
              label={`Continue ${WORK_ORDER}`}
              onClick={() => handleOpenModal("continueJob")}
            />
            <ActionButton
              icon="fa-calendar-alt"
              label="Reschedule"
              onClick={() => handleOpenModal("rescheduleJob")}
            />
            <ActionButton
              color="secondary"
              icon="fa-close"
              label={`Cancel ${WORK_ORDER}`}
              onClick={() => handleConfirmationAlerts("cancel_job")}
            />
          </div>
        );

      case "CANCELLED":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-file-alt"
              label={`${WORK_ORDER} logs`}
              onClick={() => handleOpenModal("jobLogs")}
            />
            <ActionButton
              icon="fa-download"
              label={`${WORK_ORDER} Report`}
              onClick={() => handleFileDownload("job_report")}
            />
            <ActionButton
              icon="fa-unlock"
              label={`Reopen ${WORK_ORDER}`}
              onClick={() => handleConfirmationAlerts("reopen_job")}
            />
          </div>
        );

      case "PART_REQUESTS":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-file-alt"
              label={`${WORK_ORDER}  logs`}
              onClick={() => handleOpenModal("jobLogs")}
            />
            <ActionButton
              icon="fa-download"
              label={`${WORK_ORDER} Report`}
              onClick={() => handleFileDownload("job_report")}
            />
            <ActionButton
              icon="fa-upload"
              label={`Upload ${WORK_ORDER} Files`}
              onClick={() => handleOpenModal("uploadJobFiles")}
            />
            <ActionButton
              icon="fa-shield"
              label={`${WORK_ORDER} Warranty`}
              onClick={() => handleOpenModal("jobWarranty")}
            />
            <ActionButton
              icon="fa-hourglass-half"
              label={`Continue ${WORK_ORDER}`}
              onClick={() => handleOpenModal("continueJob")}
            />
            <ActionButton
              icon="fa-calendar-alt"
              label="Reschedule"
              onClick={() => handleOpenModal("rescheduleJob")}
            />
            <ActionButton
              color="secondary"
              icon="fa-close"
              label={`Cancel ${WORK_ORDER}`}
              onClick={() => handleConfirmationAlerts("cancel_job")}
            />
          </div>
        );

      case "REPAIR":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-file-alt"
              label={`${WORK_ORDER} logs`}
              onClick={() => handleOpenModal("jobLogs")}
            />
            <ActionButton
              icon="fa-download"
              label={`${WORK_ORDER} Report`}
              onClick={() => handleFileDownload("job_report")}
            />
            <ActionButton
              icon="fa-upload"
              label={`Upload ${WORK_ORDER} Files`}
              onClick={() => handleOpenModal("uploadJobFiles")}
            />
            <ActionButton
              icon="fa-shield"
              label={`${WORK_ORDER} Warranty`}
              onClick={() => handleOpenModal("jobWarranty")}
            />
            <ActionButton
              icon="fa-hourglass-half"
              label={`Continue ${WORK_ORDER}`}
              onClick={() => handleOpenModal("continueJob")}
            />
            <ActionButton
              icon="fa-calendar-alt"
              label="Reschedule"
              onClick={() => handleOpenModal("rescheduleJob")}
            />
            {/* <ActionButton
              color="default"
              icon="fa-rotate-right"
              label="Re-Work"
              onClick={() => handleConfirmationAlerts("rework_job")}
            /> */}
            <ActionButton
              icon="fa-check"
              label={`Complete ${WORK_ORDER}`}
              onClick={() => handleConfirmationAlerts("complete_job")}
            />
            <ActionButton
              color="secondary"
              icon="fa-close"
              label={`Cancel ${WORK_ORDER}`}
              onClick={() => handleConfirmationAlerts("cancel_job")}
            />
          </div>
        );

      case "REPAIRED":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-file-alt"
              label={`${WORK_ORDER} logs`}
              onClick={() => handleOpenModal("jobLogs")}
            />
            <ActionButton
              icon="fa-download"
              label={`${WORK_ORDER} Report`}
              onClick={() => handleFileDownload("job_report")}
            />
            <ActionButton
              icon="fa-upload"
              label={`Upload ${WORK_ORDER} Files`}
              onClick={() => handleOpenModal("uploadJobFiles")}
            />
            <ActionButton
              icon="fa-shield"
              label={`${WORK_ORDER} Warranty`}
              onClick={() => handleOpenModal("jobWarranty")}
            />
            <ActionButton
              icon="fa-hourglass-half"
              label={`Continue ${WORK_ORDER}`}
              onClick={() => handleOpenModal("continueJob")}
            />
            <ActionButton
              icon="fa-calendar-alt"
              label="Reschedule"
              onClick={() => handleOpenModal("rescheduleJob")}
            />
            <ActionButton
              icon="fa-clipboard-check"
              label="Review Work Done"
              onClick={() => handleConfirmationAlerts("review_work_done")}
            />
            {/* <ActionButton
              color="secondary"
              icon="fa-close"
              label={`Cancel ${WORK_ORDER}`}
              onClick={() => handleConfirmationAlerts("cancel_job")}
            /> */}
          </div>
        );

      case "INVOICE_NOT_PAID":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-file-alt"
              label={`${WORK_ORDER} logs`}
              onClick={() => handleOpenModal("jobLogs")}
            />
            <ActionButton
              icon="fa-download"
              label={`${WORK_ORDER} Report`}
              onClick={() => handleFileDownload("job_report")}
            />
            <ActionButton
              icon="fa-upload"
              label={`Upload ${WORK_ORDER} Files`}
              onClick={() => handleOpenModal("uploadJobFiles")}
            />
            <ActionButton
              icon="fa-hourglass-half"
              label={`Continue ${WORK_ORDER}`}
              onClick={() => handleOpenModal("continueJob")}
            />
            <ActionButton
              icon="fa-calendar-alt"
              label="Reschedule"
              onClick={() => handleOpenModal("rescheduleJob")}
            />
            <ActionButton
              icon="fa-money-bill-transfer"
              label="Record Bank Transfer"
              onClick={() => handleConfirmationAlerts("bank_transfer")}
            />
            <ActionButton
              icon="fa-unlock"
              label={`Reopen ${WORK_ORDER}`}
              onClick={() => handleConfirmationAlerts("reopen_job")}
            />
            {/* <ActionButton
              color="secondary"
              icon="fa-close"
              label={`Cancel ${WORK_ORDER}`}
              onClick={() => handleConfirmationAlerts("cancel_job")}
            /> */}
          </div>
        );

      case "INVOICE_PAID":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-file-alt"
              label={`${WORK_ORDER} logs`}
              onClick={() => handleOpenModal("jobLogs")}
            />
            <ActionButton
              icon="fa-download"
              label={`${WORK_ORDER} Report`}
              onClick={() => handleFileDownload("job_report")}
            />
            <ActionButton
              icon="fa-unlock"
              label={`Reopen ${WORK_ORDER}`}
              onClick={() => handleConfirmationAlerts("reopen_job")}
            />
          </div>
        );

      case "COMPLETED":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-file-alt"
              label={`${WORK_ORDER} logs`}
              onClick={() => handleOpenModal("jobLogs")}
            />
            <ActionButton
              icon="fa-download"
              label={`${WORK_ORDER} Report`}
              onClick={() => handleFileDownload("job_report")}
            />
          </div>
        );

      case "JOB_REJECTED_BY_CLIENT":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-file-alt"
              label={`${WORK_ORDER}  logs`}
              onClick={() => handleOpenModal("jobLogs")}
            />
            <ActionButton
              icon="fa-download"
              label={`${WORK_ORDER} Report`}
              onClick={() => handleFileDownload("job_report")}
            />
            <ActionButton
              icon="fa-upload"
              label={`Upload ${WORK_ORDER} Files`}
              onClick={() => handleOpenModal("uploadJobFiles")}
            />
            <ActionButton
              icon="fa-shield"
              label={`${WORK_ORDER} Warranty`}
              onClick={() => handleOpenModal("jobWarranty")}
            />
            <ActionButton
              icon="fa-hourglass-half"
              label={`Continue ${WORK_ORDER}`}
              onClick={() => handleOpenModal("continueJob")}
            />
            <ActionButton
              icon="fa-calendar-alt"
              label="Reschedule"
              onClick={() => handleOpenModal("rescheduleJob")}
            />
            <ActionButton
              icon="fa fa-repeat"
              label="Reopen"
              onClick={() => handleReopenJob()}
            />
            <ActionButton
              color="secondary"
              icon="fa-close"
              label={`Cancel ${WORK_ORDER}`}
              onClick={() => handleConfirmationAlerts("cancel_job")}
            />
          </div>
        );

      default:
        return <></>;
    }
  };

  // used to render quotation screen actions based on job status
  const renderQuotationActionBtns = () => {
    const status = jobFormData?.jobStatus;
    const hideActions =
      (selectedServices.length === 0 && selectedParts.length === 0) ||
      (selectedParts.length > 0 &&
        selectedParts.every((part) => !part.quantity));
    switch (status) {
      case "JOB_ALLOCATED":
      case "INVOICE_NOT_PAID":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-pencil"
              label="Spare Parts"
              onClick={() => handleOpenModal("sparePartsSelection")}
            />
            <ActionButton
              icon="fa-pencil"
              label="Services"
              onClick={() => handleOpenModal("serviceSelection")}
            />
            {!hideActions && (
              <ActionButton
                icon="fa-download"
                tooltip="Download Quotation"
                onClick={() => handleFileDownload("quotation", quotationId)}
                circle
              />
            )}
          </div>
        );

      case "REQUEST_APPROVAL":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-percent"
              label="Apply Discount"
              onClick={() => handleOpenModal("applyDiscount")}
            />
            <ActionButton
              icon="fa-check-circle"
              label="Accept Quotation"
              onClick={() =>
                handleOpenModal("acceptQuotation", jobFormData?.paymentTerm?.ID)
              } //handleConfirmationAlerts("accept_quotation")
            />
            <ActionButton
              icon="fa-circle-xmark"
              label="Reject Quotation"
              onClick={() => handleConfirmationAlerts("reject_quotation")}
            />
            {/* <ActionButton
              icon="fa-envelope"
              label="Send Quotation"
              onClick={() => handleOpenModal("sendQuotation")}
            /> */}
            <ActionButton
              icon="fa-pencil"
              label="Spare Parts"
              onClick={() => handleOpenModal("sparePartsSelection")}
            />
            <ActionButton
              icon="fa-pencil"
              label="Services"
              onClick={() => handleOpenModal("serviceSelection")}
            />
            <ActionButton
              icon="fa-download"
              tooltip="Download Quotation"
              onClick={() => handleFileDownload("quotation", quotationId)}
              circle
            />
          </div>
        );

      case "QUOTATION_ACCEPTED":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-check-circle"
              label="Approve Quotation"
              onClick={() =>
                handleOpenModal("acceptQuotation", jobFormData?.paymentTerm?.ID)
              } //handleConfirmationAlerts("accept_quotation")
            />
            <ActionButton
              icon="fa-circle-xmark"
              label="Reject Quotation"
              onClick={() => handleConfirmationAlerts("reject_quotation")}
            />
            <ActionButton
              icon="fa-download"
              tooltip="Download Quotation"
              onClick={() => handleFileDownload("quotation", quotationId)}
              circle
            />
          </div>
        );

      case "QUOTATION_IN_PROGRESS":
        return (
          <div className="job-action-buttons">
            {!hideActions && (
              <ActionButton
                icon="fa-check-circle"
                label="Quotation Ready"
                onClick={() => handleConfirmationAlerts("quotation_ready")}
              />
            )}
            {!hideActions && (
              <ActionButton
                icon="fa-percent"
                label="Apply Discount"
                onClick={() => handleOpenModal("applyDiscount")}
              />
            )}
            <ActionButton
              icon="fa-pencil"
              label="Spare Parts"
              onClick={() => handleOpenModal("sparePartsSelection")}
            />
            <ActionButton
              icon="fa-pencil"
              label="Services"
              onClick={() => handleOpenModal("serviceSelection")}
            />
            {!hideActions && (
              <ActionButton
                icon="fa-download"
                tooltip="Download Quotation"
                onClick={() => handleFileDownload("quotation", quotationId)}
                circle
              />
            )}
          </div>
        );

      case "QUOTATION_ACCEPTED":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-download"
              tooltip="Download Quotation"
              onClick={() => handleFileDownload("quotation", quotationId)}
              circle
            />
          </div>
        );

      case "JOB_CREATED":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-pencil"
              label="Spare Parts"
              // onClick={() => handleAddTechnicalReportClick()}
              onClick={() => handleOpenModal("sparePartsSelection")}
            />
            <ActionButton
              icon="fa-pencil"
              label="Services"
              // onClick={() => handleAddTechnicalReportClick()}
              onClick={() => handleOpenModal("serviceSelection")}
            />
          </div>
        );
      case "QUOTATION_REJECTED":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-pencil"
              label="Spare Parts"
              onClick={() => handleOpenModal("sparePartsSelection")}
            />
            <ActionButton
              icon="fa-pencil"
              label="Services"
              onClick={() => handleOpenModal("serviceSelection")}
            />
          </div>
        );

      case "CANCELLED":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-download"
              tooltip="Download Quotation"
              onClick={() => handleFileDownload("quotation", quotationId)}
              circle
            />
          </div>
        );

      case "PART_REQUESTS":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-pencil"
              label="Spare Parts"
              onClick={() => handleOpenModal("sparePartsSelection")}
            />
            <ActionButton
              icon="fa-pencil"
              label="Services"
              onClick={() => handleOpenModal("serviceSelection")}
            />
            <ActionButton
              icon="fa-download"
              tooltip="Download Quotation"
              onClick={() => handleFileDownload("quotation", quotationId)}
              circle
            />
          </div>
        );

      case "REPAIR":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-pencil"
              label="Spare Parts"
              onClick={() => handleOpenModal("sparePartsSelection")}
            />
            <ActionButton
              icon="fa-pencil"
              label="Services"
              onClick={() => handleOpenModal("serviceSelection")}
            />
            <ActionButton
              icon="fa-download"
              tooltip="Download Quotation"
              onClick={() => handleFileDownload("quotation", quotationId)}
              circle
            />
          </div>
        );

      case "REPAIRED":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-download"
              tooltip="Download Quotation"
              onClick={() => handleFileDownload("quotation", quotationId)}
              circle
            />
          </div>
        );

      case "INVOICE_NOT_PAID":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-download"
              tooltip="Download Quotation"
              onClick={() => handleFileDownload("quotation", quotationId)}
              circle
            />
          </div>
        );

      case "INVOICE_PAID":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-download"
              tooltip="Download Quotation"
              onClick={() => handleFileDownload("quotation", quotationId)}
              circle
            />
          </div>
        );

      default:
        return <></>;
    }
  };

  // used to show edit Technician action based on job status
  const isEditableStatus = (status) => {
    const editableStatuses = [
      "JOB_ALLOCATED",
      "QUOTATION_IN_PROGRESS",
      "REQUEST_APPROVAL",
      // "CANCELLED",
      "PART_REQUESTS",
      "REPAIR",
    ];
    return editableStatuses.includes(status);
  };

  const handleAddTechnicalReportClick = () => {
    if (jobFormData?.jobStatus !== "JOB_CREATED") {
      handleOpenModal("techinicalReport");
      return;
    }

    showAlert({
      title: "Technician Not Assigned",
      type: "warning",
      message: "Please assign a technician before adding a technical report.",
      confirmStyle: "default",
      cancelStyle: "secondary",
      confirmText: "Assign Technician",
      cancelText: "Cancel",
      onConfirm: () => {
        handleOpenModal("changeTechnician");
      },
      onCancel: () => { },
    });
  };


  // used to show edit Technical report action based on job status
  const isTechReportEditable = (status) => {
    const editableStatuses = [
      "JOB_ALLOCATED",
      "QUOTATION_IN_PROGRESS",
      "REQUEST_APPROVAL",
      "QUOTATION_ACCEPTED",
      "QUOTATION_REJECTED",
      "PART_REQUESTS",
      "REPAIR",
    ];
    return editableStatuses.includes(status);
  };


  const showInternalMonitoringFlags = (status, internalTrackingFlag) => {
    if (status === "REPAIRED") {
      return true;
    }

    if (
      ["INVOICE_NOT_PAID", "INVOICE_PAID"].includes(status) &&
      internalTrackingFlag === "YES"
    ) {
      return true;
    }

    return false;
  };

  const handleInternalMonitoring = (flag) => {
    showAlert({
      title: flag === "YES"
        ? "Unmark Internal Monitoring?"
        : "Mark Internal Monitoring?",
      type: "warning",
      message: `Are you sure you want to ${flag === "YES" ? "unmark" : "mark"
        } this job for internal monitoring? This indicates that the job was completed in a single visit and is awaiting client approval.`,
      confirmStyle: "default",
      cancelStyle: "secondary",
      confirmText: "Yes",
      cancelText: "Cancel",
      onConfirm: async () => {
        setIsAPiProcessing(true);
        try {
          const res = await updateInternalMonitoring(decodedId, flag === 'YES' ? "NO" : "YES");

          if (res?.code !== 200) {
            notify("danger", res?.message || "Failed to update internal monitoring");
            return;
          }

          notify("success", res?.message || "Internal monitoring update successfully");

          await fetchQuotationList();
          await getJobDetails(decodedId);
          await timeLineDetails(decodedId);
        } catch (error) {
          notify("danger", error?.message || "Something went wrong, try again later");
        } finally {
          setIsAPiProcessing(false);
        }
      },
      onCancel: () => { },
    });
  }



  return (
    <>
      {isDownloading && (
        <div className="loading-overlay">
          <div className="loading-card">
            <i className="fa fa-spinner fa-spin fa-2x text-deep-blue mb-3" />
            <div className="font-weight-bold text-dark">
              Downloading… Please wait.
            </div>
          </div>
        </div>
      )}
      {isAPiProcessing && (
        <div className="loading-overlay">
          <div className="loading-card">
            <i className="fa fa-spinner fa-spin fa-2x text-deep-blue mb-3" />
            <div className="font-weight-bold text-dark">
              Processing… Please wait.
            </div>
          </div>
        </div>
      )}
      <div className="rna-container">
        <NotificationAlert ref={notificationAlertRef} />
      </div>
      <Container fluid className="mt-4">
        <div className="rna-container">
          <NotificationAlert ref={notificationAlertRef} />
        </div>
        <div className={`customer-card mb-3 ${jobFormData?.internalTrackingFlag === "YES" ? "monitoring-job" : ""}`}>
          <Row className="align-items-center">
            <Col md="10" sm="8" xs="12">
              <Breadcrumbs
                items={[
                  { name: `${WORK_ORDER}`, link: "/admin/jobs" },
                  { name: jobFormData.customer.label != "" ? `${jobFormData.customer.label}` : `${jobFormData?.customerLocation?.companyName}` },
                ]}
              />
            </Col>

            <Col md="2" sm="4" xs="12">
              <div className="job-id">
                <i className="fa fa-hashtag text-default mr-1" />
                {WORK_ORDER} No:{" "}
                <span className={`text-default`}>{decodedId || "NA"}</span>
              </div>
            </Col>
          </Row>

          <Row className="info-row">
            <Col md="6" sm="12" className="mt-2">
              <i className="fa fa-location-dot text-default mr-1" />
              <span>{jobFormData.customerLocation.address || "-"}</span>
            </Col>
            <Col md="4" sm="6" className="mt-2">
              <i className="fa fa-envelope text-default mr-1" />
              <span>{jobFormData.customerLocation.contactEmail || "-"}</span>
              {/* jobFormData.customer.email */}
            </Col>
            <Col md="2" sm="6" className="mt-2">
              <i className="fa fa-phone text-default mr-1" />
              <span>
                +966 {jobFormData.customerLocation.contactPersonPhone || "-"}
              </span>
              {/* jobFormData.customer.phone  */}
            </Col>
          </Row>
        </div>

        <Row>
          <Card className="m-3 border-0">
            <Nav className="custom-tabs">
              <NavItem>
                <NavLink
                  className={`text-center ${activeTab === "overview" ? "active" : ""
                    }`}
                  href="#"
                  onClick={() => toggleTab("overview")}
                >
                  Details
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={`text-center ${activeTab === "payments" ? "active" : ""
                    }`}
                  href="#"
                  onClick={() => toggleTab("payments")}
                >
                  Quotation & Payments
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={`text-center ${activeTab === "media" ? "active" : ""
                    }`}
                  href="#"
                  onClick={() => toggleTab("media")}
                >
                  Media & Documents
                </NavLink>
              </NavItem>
            </Nav>

            <CardBody>
              <TabContent activeTab={activeTab}>
                <TabPane tabId="overview">
                  <Row>
                    <Col md="8">
                      {showAlternative.loader ? (
                        <div className="loader-job-details">
                          <i className="fa fa-spinner fa-spin fa-2xl loader" />
                        </div>
                      ) : showAlternative.error &&
                        showAlternative.error !== "Not Found" ? (
                        <div className="loaderContainer text-muted d-flex flex-column">
                          <h4 className="text-muted">
                            No {SMALL_CASE_WORK_ORDER} details Available
                          </h4>
                        </div>
                      ) : (
                        <>
                          {/* <span className="text-danger">
                            Note :- *Edit Technical Report API is Pending.
                          </span> */}

                          <Card className="rounded border-0 mb-4 px-4 py-3 custom-card">
                            <h4 className="mb-3 text-default">
                              {WORK_ORDER} Information
                            </h4>
                            <div className="border-bottom border-muted mb-3" />
                            <Row>
                              <Col md="4" className="mb-3">
                                <FormGroup className="d-flex flex-column align-items-start">
                                  <Label>{WORK_ORDER} Status</Label>
                                  <span className="small-text font-weight-bold text-default text-wrap">
                                    {JOB_STATUS[jobFormData.jobStatus]?.label ||
                                      jobFormData.jobStatus}
                                  </span>
                                </FormGroup>
                              </Col>
                              <Col md="4" className="mb-3">
                                <FormGroup className="d-flex flex-column align-items-start">
                                  <Label>{WORK_ORDER} Type</Label>
                                  <span className="small-text text-wrap">
                                    {jobFormData.jobTypeID?.label || "-"}
                                  </span>
                                </FormGroup>
                              </Col>
                              {/* <Col md="4" className="mb-3">
                            <FormGroup className="d-flex flex-column align-items-start">
                              <div className="d-flex align-items-center justify-content-between w-100">
                                <Label>{WORK_ORDER} Reference Number</Label>
                                {isEditing.referenceNo.edit ? (
                                  <div className="d-flex align-items-center">
                                    <div
                                      className="d-flex align-items-center justify-content-center rounded-circle pointer mx-2"
                                      onClick={() => handleClose("referenceNo")}
                                    >
                                      <i className="tim-icons icon-simple-remove text-dark" />
                                    </div>
                                    <div
                                      className="d-flex align-items-center justify-content-center rounded-circle pointer"
                                      onClick={() => handleSave("referenceNo")}
                                    >
                                      <i className="tim-icons icon-check-2 text-dark tim-md" />
                                    </div>
                                  </div>
                                ) : (
                                  <div
                                    className="d-flex align-items-center justify-content-center rounded-circle pointer"
                                    onClick={() => handleEdit("referenceNo")}
                                  >
                                    <i className="tim-icons icon-pencil text-dark" />
                                  </div>
                                )}
                              </div>
                              {isEditing.referenceNo.edit ? (
                                <FormGroup className="d-flex flex-column align-items-start">
                                  <Input
                                    type="text"
                                    name="referenceNo"
                                    placeholder="Enter reference number"
                                    className="mt-1"
                                    value={isEditing.referenceNo.value}
                                    onChange={(e) =>
                                      handleChange(
                                        "referenceNo",
                                        e.target.value
                                      )
                                    }
                                  />
                                </FormGroup>
                              ) : (
                                <span className="small-text">
                                  {editableData.referenceNo || "-"}
                                </span>
                              )}
                            </FormGroup>
                          </Col> */}

                              <Col md="4" className="mb-3">
                                <FormGroup className="d-flex flex-column align-items-start">
                                  <div className="d-flex align-items-center justify-content-between w-100">
                                    <Label>{WORK_ORDER} Reference Number</Label>
                                    {/* {isEditing.referenceNo.edit ? (
                                      <div className="d-flex align-items-center">
                                        <div
                                          className="d-flex align-items-center justify-content-center rounded-circle pointer mx-2"
                                          onClick={() =>
                                            handleClose("referenceNo")
                                          }
                                        >
                                          <i className="tim-icons icon-simple-remove text-dark" />
                                        </div>
                                        <div
                                          className="d-flex align-items-center justify-content-center rounded-circle pointer"
                                          onClick={() =>
                                            handleSave("referenceNo")
                                          }
                                        >
                                          <i className="tim-icons icon-check-2 text-dark tim-md" />
                                        </div>
                                      </div>
                                    ) : (
                                      <div
                                        className="d-flex align-items-center justify-content-center rounded-circle pointer"
                                        onClick={() =>
                                          handleEdit("referenceNo")
                                        }
                                      >
                                        <i className="tim-icons icon-pencil text-dark" />
                                      </div>
                                    )} */}
                                  </div>
                                  {/* {isEditing.referenceNo.edit ? (
                                    <FormGroup className="d-flex flex-column align-items-start">
                                      <Input
                                        type="text"
                                        name="referenceNo"
                                        placeholder="Enter PO number"
                                        className="mt-1"
                                        value={isEditing.referenceNo.value}
                                        onChange={(e) =>
                                          handleChange(
                                            "referenceNo",
                                            e.target.value,
                                          )
                                        }
                                      />
                                    </FormGroup>
                                  ) : ( */}
                                  <p className="small-text text-muted mb-2 text-wrap">
                                    {jobFormData?.jobReferenceNo?.value || "-"}
                                  </p>
                                  {/* )} */}
                                </FormGroup>
                              </Col>
                              <Col md="4" className="mb-3">
                                <FormGroup className="d-flex flex-column align-items-start">
                                  <div className="d-flex align-items-center justify-content-between w-100">
                                    <Label>
                                      {WORK_ORDER} Sales Order Number
                                    </Label>
                                    {isEditing.jobSalesOrderNo.edit ? (
                                      <div className="d-flex align-items-center">
                                        <div
                                          className="d-flex align-items-center justify-content-center px-3 py-2 border rounded text-center pointer btn-secondary mx-2"
                                          onClick={() =>
                                            handleClose("jobSalesOrderNo")
                                          }
                                        >
                                          <i className="tim-icons icon-simple-remove text-dark" />
                                        </div>
                                        <div
                                          className="d-flex align-items-center justify-content-center px-3 py-2 border rounded text-center pointer btn-secondary"
                                          onClick={() =>
                                            handleSave("jobSalesOrderNo")
                                          }
                                        >
                                          <i className="tim-icons icon-check-2 text-dark" />
                                        </div>
                                      </div>
                                    ) : (
                                      <div
                                        className="d-flex align-items-center justify-content-center px-3 py-2 border rounded text-center pointer btn-secondary"
                                        onClick={() =>
                                          handleEdit("jobSalesOrderNo")
                                        }
                                      >
                                        <i className="tim-icons icon-pencil text-dark" />
                                      </div>
                                    )}
                                  </div>
                                  {isEditing.jobSalesOrderNo.edit ? (
                                    <FormGroup
                                      className={`d-flex flex-column align-items-start ${editableData.jobSalesOrderNo.error
                                        ? "has-danger"
                                        : ""
                                        }`}
                                    >
                                      <Input
                                        type="text"
                                        name="jobSalesOrderNo"
                                        placeholder="Enter sales order no"
                                        onBlur={() =>
                                          handleBlurValidation(
                                            "jobSalesOrderNo",
                                          )
                                        }
                                        className="mt-1"
                                        value={isEditing.jobSalesOrderNo.value}
                                        onChange={(e) =>
                                          handleChange(
                                            "jobSalesOrderNo",
                                            e.target.value,
                                          )
                                        }
                                      />
                                      {editableData.jobSalesOrderNo.error && (
                                        <div className="text-danger small">
                                          {editableData.jobSalesOrderNo.error}
                                        </div>
                                      )}
                                    </FormGroup>
                                  ) : (
                                    <p className="small-text text-muted mb-2 text-wrap">
                                      {jobFormData.jobSalesOrderNo || "-"}
                                    </p>
                                  )}
                                </FormGroup>
                              </Col>
                              <Col md="4" className="mb-3">
                                <FormGroup className="d-flex flex-column align-items-start">
                                  <Label>{WORK_ORDER} Warranty</Label>
                                  <span className="small-text text-wrap">
                                    {jobFormData.underWarranty || "-"}
                                  </span>
                                </FormGroup>
                              </Col>
                              <Col md="4" className="mb-3">
                                <FormGroup className="d-flex flex-column align-items-start">
                                  {jobFormData?.jobStatus !== "JOB_CREATED" ? (
                                    <>
                                      <div className="d-flex align-items-center justify-content-between w-100">
                                        <Label>Assigned Technician</Label>

                                        {isEditableStatus(
                                          jobFormData?.jobStatus,
                                        ) && (
                                            <div
                                              className="d-flex align-items-center justify-content-center px-3 py-2 border rounded text-center pointer btn-secondary"
                                              onClick={() =>
                                                handleOpenModal(
                                                  "changeTechnician",
                                                )
                                              }
                                            >
                                              <i className="tim-icons icon-pencil text-dark" />
                                            </div>
                                          )}
                                      </div>

                                      <span className="small-text">
                                        {jobFormData?.technician?.label || "-"}
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <Label>Assign Technician</Label>
                                      <button
                                        type="button"
                                        className="btn btn-default btn-sm mt-1"
                                        onClick={() =>
                                          handleOpenModal("changeTechnician")
                                        }
                                      >
                                        Assign Technician
                                      </button>
                                    </>
                                  )}
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row className="mb-4 d-flex flex-wrap align-items-center justify-content-end">
                              <Col className="d-flex flex-wrap" md="auto">
                                {renderJobInfoActionBtns()}
                              </Col>
                            </Row>
                          </Card>
                          <Card className="rounded border-0 mb-4 px-4 py-3 custom-card">
                            <h4 className="mb-3 text-default">
                              Service location Details
                            </h4>
                            <div className="border-bottom border-muted mb-3" />
                            <Row>
                              <Col md="4" className="mb-3">
                                <FormGroup className="d-flex flex-column align-items-start">
                                  <Label>Outlet</Label>
                                  <span className="small-text text-wrap">
                                    {jobFormData.customerLocation.outletName ||
                                      "-"}
                                  </span>
                                </FormGroup>
                              </Col>
                              <Col md="4" className="mb-3">
                                <FormGroup className="d-flex flex-column align-items-start">
                                  <Label>Address</Label>
                                  <span className="small-text text-wrap">
                                    {jobFormData.customerLocation.address ||
                                      "-"}
                                  </span>
                                </FormGroup>
                              </Col>
                              <Col md="4" className="mb-3">
                                <FormGroup className="d-flex flex-column align-items-start">
                                  <Label>Contact Person</Label>
                                  <span className="small-text text-wrap">
                                    {jobFormData.customerLocation
                                      .contactPersonName || "-"}
                                  </span>
                                </FormGroup>
                              </Col>
                              <Col md="4" className="mb-3">
                                <FormGroup className="d-flex flex-column align-items-start">
                                  <Label>Email Address</Label>
                                  <span className="small-text text-wrap">
                                    {jobFormData.customerLocation
                                      .contactEmail || "-"}
                                  </span>
                                </FormGroup>
                              </Col>
                              <Col md="4" className="mb-3">
                                <FormGroup className="d-flex flex-column align-items-start">
                                  <Label>Contact Number</Label>
                                  <span className="small-text text-wrap">
                                    {jobFormData.customerLocation
                                      .contactPersonPhone || "-"}
                                  </span>
                                </FormGroup>
                              </Col>
                              {jobFormData.customerLocation
                                .alternateContactPersonName !== "" ? (
                                <Col md="4" className="mb-3">
                                  <FormGroup className="d-flex flex-column align-items-start">
                                    <Label>Alternate Contact Person</Label>
                                    <span className="small-text text-wrap">
                                      {jobFormData.customerLocation
                                        .alternateContactPersonName || "-"}
                                    </span>
                                  </FormGroup>
                                </Col>
                              ) : (
                                ""
                              )}
                              {jobFormData.customerLocation
                                .alternateContactEmail !== "" ? (
                                <Col md="4" className="mb-3">
                                  <FormGroup className="d-flex flex-column align-items-start">
                                    <Label>Alternate Email Address</Label>
                                    <span className="small-text text-wrap">
                                      {jobFormData.customerLocation
                                        ?.alternateContactEmail || "-"}
                                    </span>
                                  </FormGroup>
                                </Col>
                              ) : (
                                ""
                              )}
                              {jobFormData.customerLocation
                                .alternateContactPersonPhone !== "" ? (
                                <Col md="4" className="mb-3">
                                  <FormGroup className="d-flex flex-column align-items-start">
                                    <Label>Alternate Contact Number</Label>
                                    <span className="small-text text-wrap">
                                      {jobFormData.customerLocation
                                        ?.alternateContactPersonPhone || "-"}
                                    </span>
                                  </FormGroup>
                                </Col>
                              ) : (
                                ""
                              )}
                              <Col md="4" className="mb-3">
                                <FormGroup className="d-flex flex-column align-items-start">
                                  <Label>Customer Payment Term</Label>
                                  <span className="small-text text-wrap">
                                    {PAYMENT_TERMS_STATUS[
                                      jobFormData.paymentTerm?.term
                                    ]?.label || "-"}
                                  </span>
                                </FormGroup>
                              </Col>
                            </Row>
                          </Card>
                          <Card className="rounded border-0 mb-4 px-4 py-3 custom-card">
                            <h4 className="mb-3 text-default">
                              Product Details
                            </h4>
                            <div className="border-bottom border-muted mb-3" />
                            <Row>
                              <Col md="4" className="mb-3">
                                <FormGroup className="d-flex flex-column align-items-start">
                                  <Label>Manufacturer</Label>
                                  <span className="small-text text-wrap">
                                    {jobFormData.manufacturer.label || "-"}
                                  </span>
                                </FormGroup>
                              </Col>
                              <Col md="4" className="mb-3">
                                <FormGroup className="d-flex flex-column align-items-start">
                                  <Label>Product Name</Label>
                                  <span className="small-text text-wrap">
                                    {jobFormData.product.label || "-"}
                                  </span>
                                </FormGroup>
                              </Col>
                              <Col md="4" className="mb-3">
                                <FormGroup className="d-flex flex-column align-items-start">
                                  <Label>Model</Label>
                                  <span className="small-text text-wrap">
                                    {jobFormData.product.modelNo || "-"}
                                  </span>
                                </FormGroup>
                              </Col>
                              <Col md="4" className="mb-3">
                                <FormGroup className="d-flex flex-column align-items-start">
                                  <Label>Serial No.</Label>
                                  <span className="small-text text-wrap">
                                    {jobFormData.customerEquipment.serialNo ||
                                      "-"}
                                  </span>
                                </FormGroup>
                              </Col>
                              <Col md="4" className="mb-3">
                                <FormGroup className="d-flex flex-column align-items-start">
                                  <Label>Warranty</Label>
                                  <span className="small-text text-wrap">
                                    {jobFormData.customerEquipment
                                      .underWarranty || "-"}
                                  </span>
                                </FormGroup>
                              </Col>
                              <Col md="4" className="mb-3">
                                <FormGroup className="d-flex flex-column align-items-start">
                                  <Label>Asset Tag</Label>
                                  <span className="small-text text-wrap">
                                    {jobFormData.customerEquipment.assetTag ||
                                      "-"}
                                  </span>
                                </FormGroup>
                              </Col>
                              <Col md="4" className="mb-3">
                                <FormGroup className="d-flex flex-column align-items-start">
                                  <Label>Seller</Label>
                                  <span className="small-text text-wrap">
                                    {jobFormData.customerEquipment.seller
                                      ? jobFormData.customerEquipment.seller
                                        .charAt(0)
                                        .toUpperCase() +
                                      jobFormData.customerEquipment.seller
                                        .slice(1)
                                        .toLowerCase()
                                      : "-"}
                                  </span>
                                </FormGroup>
                              </Col>
                              <Col md="4" className="mb-3">
                                <FormGroup className="d-flex flex-column align-items-start">
                                  <Label>Purchase Date</Label>
                                  <span className="small-text text-wrap">
                                    {jobFormData.purchaseDate || "-"}
                                  </span>
                                </FormGroup>
                              </Col>
                              <Col md="4" className="mb-3">
                                <FormGroup className="d-flex flex-column align-items-start">
                                  <Label>Purchase Invoice</Label>
                                  <span className="small-text text-wrap">
                                    {jobFormData.customerEquipment
                                      .invoicePath !== "" ? (
                                      <span
                                        className="text-info pointer"
                                        onClick={() =>
                                          handleFileDownload(
                                            "invoice",
                                            jobFormData?.customerEquipment
                                              ?.value,
                                          )
                                        }
                                      >
                                        Download
                                      </span>
                                    ) : (
                                      "-"
                                    )}
                                  </span>
                                </FormGroup>
                              </Col>
                            </Row>
                          </Card>
                          <Row>
                            <Col md="6">
                              <Card className="rounded border-0 mb-4 px-4 py-3 custom-card">
                                <h4 className="mb-3 text-default">
                                  Client-Reported Problem
                                </h4>
                                <div className="border-bottom border-muted mb-3" />
                                <span className="small-text">
                                  {jobFormData.clientNote || "-"}
                                </span>
                              </Card>
                            </Col>
                            <Col md="6">
                              <Card className="rounded border-0 mb-4 px-4 py-3 custom-card">
                                <div className="d-flex align-items-center justify-content-between w-100 mb-3">
                                  <h4 className="text-default mb-0">
                                    Admin Notes
                                  </h4>
                                  <div className="d-flex align-items-center">
                                    {isEditing.notes.edit ? (
                                      <div className="d-flex align-items-center">
                                        <div
                                          className="d-flex align-items-center justify-content-center px-3 py-2 border rounded text-center pointer btn-secondary mx-2"
                                          onClick={() => handleClose("notes")}
                                        >
                                          <i className="tim-icons icon-simple-remove text-dark" />
                                        </div>

                                        <div
                                          className="d-flex align-items-center justify-content-center px-3 py-2 border rounded text-center pointer btn-secondary"
                                          onClick={() => handleSave("notes")}
                                        >
                                          <i className="tim-icons icon-check-2 text-dark" />
                                        </div>
                                      </div>
                                    ) : (
                                      <div
                                        className="d-flex align-items-center justify-content-center px-3 py-2 border rounded text-center pointer btn-secondary"
                                        onClick={() => handleEdit("notes")}
                                      >
                                        <i className="tim-icons icon-pencil text-dark" />
                                      </div>
                                    )}
                                    {showInternalMonitoringFlags(jobFormData?.jobStatus, jobFormData?.internalTrackingFlag) && <div className="ml-2 px-3 py-1 border rounded text-center pointer btn-secondary"
                                      onClick={() => handleInternalMonitoring(jobFormData.internalTrackingFlag)}>
                                      <span>{jobFormData.internalTrackingFlag === "YES" ? "Unmark" : "Mark"}</span>
                                    </div>}
                                  </div>

                                </div>
                                <div className="border-bottom border-muted mb-3" />
                                <div>
                                  {isEditing.notes.edit ? (
                                    <FormGroup
                                      className={`d-flex flex-column align-items-start ${editableData.notes.error
                                        ? "has-danger"
                                        : ""
                                        }`}
                                    >
                                      <Input
                                        type="textarea"
                                        name="notes"
                                        placeholder="Enter coordinator notes"
                                        value={isEditing.notes.value}
                                        onBlur={() =>
                                          handleBlurValidation("notes")
                                        }
                                        onChange={(e) =>
                                          handleChange("notes", e.target.value)
                                        }
                                      />
                                      {editableData.notes.error && (
                                        <div className="text-danger small">
                                          {editableData.notes.error}
                                        </div>
                                      )}
                                    </FormGroup>
                                  ) : (
                                    <span className="small-text">
                                      {jobFormData.adminNote.value || "-"}
                                    </span>
                                  )}
                                </div>
                              </Card>
                            </Col>
                          </Row>
                          <Row className="g-3">
                            {/* Schedule Date & Time */}
                            <Col md="6" className="d-flex">
                              <Card className="rounded border-0 mb-0 px-4 py-3 custom-card schedule-box w-100">
                                <h4 className="mb-3 text-default">Schedule Date & Time</h4>
                                <div className="custom-timeline px-4">
                                  <div className="border-bottom border-muted mb-3" />
                                  {jobFormData?.jobSchedules?.length ? (
                                    jobFormData.jobSchedules.map((item, index) => (
                                      <div key={index} className="mb-3">
                                        <h5 className="text-default mb-2">Day {index + 1}:</h5>
                                        <Row className="d-flex align-items-start mb-0 p-0 g-2">
                                          <Col xs="6">
                                            <FormGroup className="d-flex flex-column align-items-start mb-0">
                                              <Label className="mb-1">Start</Label>
                                              <span className="small-text">{item.scheduledFrom || "-"}</span>
                                            </FormGroup>
                                          </Col>
                                          <Col xs="6">
                                            <FormGroup className="d-flex flex-column align-items-start mb-0">
                                              <Label className="mb-1">End</Label>
                                              <span className="small-text">{item.scheduledTo || "-"}</span>
                                            </FormGroup>
                                          </Col>
                                        </Row>
                                      </div>
                                    ))
                                  ) : (
                                    <span className="small-text text-muted">No schedules</span>
                                  )}
                                </div>
                              </Card>
                            </Col>

                            {/* Right column: Cancelled Reason + Feedback */}
                            <Col md="6" className="d-flex flex-column" style={{ gap: "0.75rem" }}>
                              {jobFormData?.cancelledReason && (
                                <Card className="rounded border-0 mb-0 px-4 py-3 custom-card">
                                  <h4 className="mb-3 text-default">{WORK_ORDER} Cancelled Reason</h4>
                                  <div className="border-bottom border-muted mb-3" />
                                  <FormGroup className="d-flex flex-column align-items-start mb-0">
                                    <Label className="mb-1">Reason</Label>
                                    <span className="small-text text-wrap">{jobFormData.cancelledReason}</span>
                                  </FormGroup>
                                </Card>
                              )}

                              <Card className="rounded border-0 mb-0 px-4 py-3 custom-card flex-grow-1">
                                <h4 className="mb-3 text-default">{WORK_ORDER} Feedback</h4>
                                <div className="border-bottom border-muted mb-3" />
                                {showAlternative.feedbackError &&
                                  showAlternative.feedbackError !== "Not Found" ? (
                                  <div className="loaderContainer text-muted d-flex flex-column">
                                    <span className="text-danger">{showAlternative.feedbackError}</span>
                                  </div>
                                ) : (
                                  <Row className="g-2">
                                    <Col xs="6" className="mb-2">
                                      <FormGroup className="d-flex flex-column align-items-start mb-0">
                                        <Label className="mb-1">Date</Label>
                                        <span className="small-text">{feedback.dateCreated || "-"}</span>
                                      </FormGroup>
                                    </Col>
                                    <Col xs="6" className="mb-2">
                                      <FormGroup className="d-flex flex-column align-items-start mb-0">
                                        <Label className="mb-1">Rating</Label>
                                        <span className="small-text">{renderStars(feedback.rating)}</span>
                                      </FormGroup>
                                    </Col>
                                    <Col xs="12" className="mb-0">
                                      <FormGroup className="d-flex flex-column align-items-start mb-0">
                                        <Label className="mb-1">Comments</Label>
                                        <span className="small-text text-wrap">{feedback.comment || "-"}</span>
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                )}
                              </Card>
                            </Col>
                          </Row>


                        </>
                      )}
                    </Col>

                    <Col md="4">
                      <Card className="roundedmb-4 px-4 py-3 custom-card">
                        <Row className="align-items-center mb-3">
                          <Col>
                            <h4 className="text-default mb-0">
                              Technical Report
                            </h4>
                          </Col>
                          {!techRepoFormData?.ID?.value &&
                            isTechReportEditable(
                              jobFormData?.jobStatus,
                            ) && (
                              <div className="d-flex justify-content-end">
                                <Button
                                  color="default"
                                  size="sm"
                                  onClick={handleAddTechnicalReportClick}
                                >
                                  <i className="fa fa-plus mr-1" />
                                  Add
                                </Button>
                              </div>
                            )}
                          {/* (jobFormData?.jobStatus === "JOB_ALLOCATED" ||
                              jobFormData?.jobStatus ===
                              "QUOTATION_IN_PROGRESS" ||
                              jobFormData?.jobStatus ===
                              "REQUEST_APPROVAL") && */}
                          {techRepoFormData?.ID?.value &&
                            isTechReportEditable(
                              jobFormData?.jobStatus,
                            ) &&
                            (<div className="d-flex justify-content-end">
                              <Button
                                color="default"
                                size="sm"
                                onClick={handleAddTechnicalReportClick}
                              >
                                <i className="fa fa-pen mr-1" />
                                Edit
                              </Button>
                            </div>
                            )}
                        </Row>

                        <div className="border-bottom border-muted mb-3" />
                        {showAlternative.techRepoLoader ? (
                          <div className="loaderContainer">
                            <i className="fa fa-spinner fa-spin fa-2xl loader" />
                          </div>
                        ) : showAlternative.techRepoError &&
                          showAlternative.techRepoError !== "Not Found" ? (
                          <div className="loaderContainer text-muted d-flex flex-column">
                            <h4 className="text-muted">
                              No technical report available
                            </h4>
                          </div>
                        ) : (
                          <Row>
                            {/* <Col md="6" className="mb-3">
                              <FormGroup className="d-flex flex-column align-items-start">
                                <div className="d-flex align-items-center justify-content-between w-100">
                                  <Label>Technician</Label>
                                  {isEditableStatus(jobFormData?.jobStatus) && (
                                    <div
                                      className="d-flex align-items-center justify-content-center rounded-circle pointer"
                                      onClick={() =>
                                        handleOpenModal("changeTechnician")
                                      }
                                    >
                                      <i className="tim-icons icon-pencil text-dark" />
                                    </div>
                                  )}
                                </div>

                                <span className="small-text">
                                  {techRepoFormData?.technicianID?.label || "-"}
                                </span>
                              </FormGroup>
                            </Col> */}
                            <Col md="6" className="mb-3">
                              <FormGroup className="d-flex flex-column align-items-start">
                                <Label>Serial No</Label>
                                <span className="small-text">
                                  {techRepoFormData?.serialNo?.value || "-"}
                                </span>
                              </FormGroup>
                            </Col>
                            <Col md="12" className="mb-3">
                              <FormGroup className="d-flex flex-column align-items-start">
                                <Label>Findings</Label>
                                <span className="small-text">
                                  {techRepoFormData?.otherFinding?.value || "-"}
                                </span>
                              </FormGroup>
                            </Col>
                            <Col md="12" className="mb-3">
                              <FormGroup className="d-flex flex-column align-items-start">
                                <Label>Cause of Failure</Label>
                                <span className="small-text">
                                  {techRepoFormData?.causeOfFailure?.value ||
                                    "-"}
                                </span>
                              </FormGroup>
                            </Col>
                            <Col md="12" className="mb-3">
                              <FormGroup className="d-flex flex-column align-items-start">
                                <Label>Other Actions</Label>
                                <span className="small-text">
                                  {techRepoFormData?.additionalInfo?.value ||
                                    "-"}
                                </span>
                              </FormGroup>
                            </Col>
                            <Col md="12">
                              {/* <Card className="rounded mb-4 px-4 py-3 custom-card"> */}
                              {/* <Row className="align-items-center mb-2">
                                <Col>
                                  <Label>Attachments</Label>
                                </Col>
                              </Row> */}

                              {/* <div className="border-bottom border-muted mb-3" /> */}

                              {/* <Row>
                                <Col>
                                  <div className="media-grid-repo d-flex flex-nowrap pb-2">
                                    {techRepoFormData.media.map((med) => {
                                      const src =
                                        med.mediaPath?.default || med.mediaPath;
                                      const isVideo =
                                        typeof src === "string" &&
                                        src
                                          .toLowerCase()
                                          .endsWith(
                                            ".mp4" || "mov" || "avi" || "mkv",
                                          );

                                      return (
                                        <div
                                          key={med.ID}
                                          className="media-card"
                                          onClick={() => setSelectedImage(src)}
                                        >
                                          <div className="media-preview-wrapper">
                                            {isVideo ? (
                                              <div className="video-preview-wrapper position-relative">
                                                <video
                                                  src={src}
                                                  className="media-preview"
                                                // muted
                                                // controls
                                                />
                                                <span className="video-play-btn position-absolute">
                                                  <i className="fa fa-play" />
                                                </span>
                                              </div>
                                            ) : (
                                              <img
                                                src={src}
                                                alt="product"
                                                className="media-preview"
                                              />
                                            )}
                                          </div>

                                          <div className="media-info">
                                            <div className="media-title text-truncate">
                                              Product Image {med.ID}
                                            </div>

                                            <div
                                              className="media-actions"
                                              onClick={(e) =>
                                                e.stopPropagation()
                                              }
                                            >
                                              <span
                                                className="link-action view-link"
                                                onClick={() =>
                                                  setSelectedImage(src)
                                                }
                                              >
                                                <i className="fa fa-eye mr-1" />
                                              </span>

                                              <span
                                                className="link-action download-link"
                                                onClick={() => {
                                                  const a =
                                                    document.createElement("a");
                                                  a.href = src;
                                                  a.target = "_blank";
                                                  a.download = `product-media-${med.ID}`;
                                                  a.click();
                                                }}
                                              >
                                                <i className="fa fa-download mr-1" />
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </Col>
                              </Row> */}
                              {/* </Card> */}
                            </Col>
                          </Row>
                        )}
                      </Card>

                      <Card className="rounded border-0 mb-0 px-4 py-3 custom-card timeline-box">
                        <h4 className="mb-3 text-default">Timeline</h4>
                        <div className="border-bottom border-muted mb-0" />
                        <Card className="custom-timeline card-timeline card-plain mb-0">
                          {showAlternative.timeLineLoader ? (
                            <div className="loaderContainer">
                              <i className="fa fa-spinner fa-spin fa-2xl loader" />
                            </div>
                          ) : showAlternative.timeLineError ||
                            timeline.length === 0 ? (
                            <div className="loaderContainer text-muted d-flex flex-column">
                              <h4 className="text-muted">
                                No time line Available
                              </h4>
                            </div>
                          ) : (
                            <CardBody>
                              <ul className="timeline timeline-simple mb-0 px-2">
                                {timeline.map((item, index) => (
                                  <li className="timeline-inverted" key={index}>
                                    <div
                                      className={`timeline-badge ${item.color}`}
                                    >
                                      <i
                                        className={`tim-icons fa-sm ${item.icon}`}
                                      />
                                    </div>
                                    <div className="timeline-panel">
                                      <div className="timeline-heading job-heading mb-2">
                                        {item.event}
                                      </div>
                                      <div className="timeline-body job-subHeading">
                                        {item.date}
                                      </div>
                                    </div>
                                  </li>
                                ))}
                              </ul>
                            </CardBody>
                          )}
                        </Card>
                      </Card>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabId="payments">
                  <QuotationAndPayments
                    quotationLoading={quotationListState.loader}
                    quotationError={quotationListState.error}
                    sampleData={sampleData}
                    showDetails={showDetails}
                    setShowDetails={setShowDetails}
                    renderQuotationActionBtns={renderQuotationActionBtns}
                    handleFileDownload={handleFileDownload}
                    decodedId={decodedId}
                    selectedParts={selectedParts}
                    selectedServices={selectedServices}
                    quotationSummary={quotationSummary}
                  ></QuotationAndPayments>
                </TabPane>
                <TabPane tabId="media">
                  <MediaAndDocuments
                    activeTab={activeTab}
                    setSelectedImage={setSelectedImage}
                    setSelectedPDF={setSelectedPDF}
                    setSelectedVideo={setSelectedVideo}
                    handleFileDownload={handleFileDownload}
                    decodedId={decodedId}
                    notify={notify}
                  ></MediaAndDocuments>
                </TabPane>
              </TabContent>
            </CardBody>
          </Card>
          <CustomModal
            isOpen={!!selectedImage}
            onClose={() => setSelectedImage(null)}
            title="Image Preview"
          >
            <div className="image-container">
              <img
                src={selectedImage}
                alt="Full preview"
                className="image-preview"
              />
            </div>
          </CustomModal>
          <CustomModal
            isOpen={!!selectedPDF}
            onClose={() => setSelectedPDF(null)}
            title={"Document Preview"}
          >
            <div className="pdf-container">
              <iframe
                src={selectedPDF}
                title="PDF Viewer"
                className="pdf-iframe"
              />
            </div>
          </CustomModal>
          <CustomModal
            isOpen={!!selectedVideo}
            onClose={() => setSelectedVideo(null)}
            title="Video Preview"
          >
            <div className="image-container">
              <video
                src={selectedVideo}
                className="image-preview"
                controls
                muted
              />
            </div>
          </CustomModal>
        </Row>
      </Container>

      <AddTechnicalReport
        isOpen={isOpen.techinicalReport}
        handleClose={handleCloseModal}
        decodedId={decodedId}
        notify={notify}
        technicalReportDetails={technicalReportDetails}
        technicianID={jobFormData?.technician?.value}
        techRepoFormData={techRepoFormData}
      />

      <ChangeTechnician
        isOpen={isOpen.changeTechnician}
        handleClose={handleCloseModal}
        regionId={jobFormData?.customerLocation.regionID}
        jobID={decodedId}
        technician={jobFormData.technician}
        onSuccess={handleTechnicianUpdated}
      />

      <UploadJobFiles
        isOpen={isOpen.uploadJobFiles}
        handleClose={handleCloseModal}
        decodedId={decodedId}
        notify={notify}
      />

      <JobLogs
        isOpen={isOpen.jobLogs}
        handleClose={handleCloseModal}
        decodedId={decodedId}
        activeTab={activeTab}
      />

      <SendQuotation
        isOpen={isOpen.sendQuotation}
        handleClose={handleCloseModal}
      />

      <JobWarranty
        isOpen={isOpen.jobWarranty}
        handleClose={handleCloseModal}
        notify={notify}
        onSuccess={() => {
          getJobDetails(decodedId);
        }}
        underWarranty={jobFormData?.underWarranty}
        warrantyNote={jobFormData?.warrantyNote}
      />

      <ContinueJob
        isOpen={isOpen.continueJob}
        regionId={jobFormData?.customerLocation.regionID}
        technicianID={jobFormData?.technician?.value}
        handleClose={handleCloseModal}
        handleSave={(payload) => handleContinueJob(payload)}
        jobSchedules={jobFormData?.jobSchedules}
        isLoading={isSaveClicked}
      />

      <RescheduleJob
        isOpen={isOpen.rescheduleJob}
        handleClose={handleCloseModal}
        technicianID={jobFormData?.technician?.value} //send technician id to auto fill in reschedule job
        decodedId={decodedId}
        onRescheduleSuccess={() => {
          timeLineDetails(decodedId); //after sucess get timeline details
          getJobDetails(decodedId); //same for job details
        }}
        notify={notify}
        jobSchedules={jobFormData?.jobSchedules}
      />

      <SparePartsSelection
        isOpen={isOpen.sparePartsSelection}
        handleClose={handleCloseModal}
        status={jobFormData?.jobStatus}
        selectedParts={selectedParts}
        selectedReasonID={(id) => setRequoteReasonId(id)}
        onSave={(parts) => {
          saveQuotation(parts, selectedServices);
        }}
        isSaveClicked={isSaveClicked}
      />

      <ServiceSelection
        isOpen={isOpen.serviceSelection}
        handleClose={handleCloseModal}
        status={jobFormData?.jobStatus}
        selectedServices={selectedServices}
        selectedReasonID={(id) => setRequoteReasonId(id)}
        onSave={(services) => {
          saveQuotation(selectedParts, services);
        }}
        isSaveClicked={isSaveClicked}
      />

      <ApplyDiscount
        isOpen={isOpen.applyDiscount}
        handleClose={handleCloseModal}
        quotationId={quotationId}
        quotationItems={[...(selectedParts || []), ...(selectedServices || [])]}
        onDiscountApplied={fetchQuotationList}
      />

      <AcceptQuotation
        isOpen={isOpen.acceptQuotation}
        handleClose={handleCloseModal}
        onAccept={(formValues) => {
          handleApprovedQuotation(formValues);
        }}
        paymentTerm={isOpen.paymentTerm || jobFormData?.paymentTerm?.ID}
        isLoading={isSaveClicked}
      />
    </>
  );
}

export default JobDetails;
